/* The Future Files — Predictions tab, data search (/v1/ask, rule-based), password gate, footer player (2026-09-22, rev 09-23)
 * Classic script (not a module) on purpose: it reaches theme.js top-level bindings
 * (typewriterTimeout, charIndex, isDeleting, funnyPhrases, typewriterText, ...).
 */
(function () {
  'use strict';

  /* API hosts: primary + automatic fallback. The working host is remembered for this tab (sessionStorage). */
  var API_BASES = (window.TFF && window.TFF.apiBases) || [(window.TFF && window.TFF.apiBase) || 'https://api.thefuturefiles.com', 'https://3-80-198-229.sslip.io'];
  var API = API_BASES[0];
  try { var _sb = sessionStorage.getItem('tff_api_base'); if (_sb && API_BASES.indexOf(_sb) >= 0) API = _sb; } catch (e) {}
  function useBase(b) { if (b === API) return; API = b; try { sessionStorage.setItem('tff_api_base', b); } catch (e) {} }
  function wsBase() { return API.replace(/^http/, 'ws'); }
  var VENUES = {
    kalshi: { name: 'Kalshi', color: '#1CDA82', soft: 'rgba(28,218,130,.14)', logo: kalshiLogo },
    polymarket: { name: 'Polymarket', color: '#2E5CFF', soft: 'rgba(46,92,255,.16)', logo: polyLogo }
  };
  var AI_PHRASES = [
    '"Backtest buying baseball yes contracts at 20 cents"',
    '"Backtest buying baseball yes contracts at 20 cents"',
    '"Kalshi total volume over the past year"',
    '"Which Polymarket categories traded the most this month"',
    '"Win rate of NO at 5 cents on daily weather"'
  ];

  /* ------------------------------------------------------------------ ranges + intervals
   * Ported from the desktop app (ui/src/markets-legacy.js). RANGES are what the visitor picks;
   * INTERVALS are the bucket the API is actually asked for. 3 months of history, minute bars and
   * tick-level are what the $20/month subscription buys, and all three are SHOWN padlocked rather
   * than hidden — a control you cannot see is not an offer. */
  var RANGES = [
    { v: '24h', label: '24H', days: 1 },
    { v: '7d', label: '7D', days: 7 },
    { v: '30d', label: '30D', days: 30 },
    { v: '3m', label: '3M', days: 91, pro: true },
    { v: 'custom', label: 'Custom', custom: true }
  ];
  /* PRO_BUCKETS — the free tier's floor, stated once, in the client.
   *
   * The free ceiling is FIVE-MINUTE BARS. `1m` and `tick` are both part of the $20/month
   * subscription and neither is ever free.
   *
   * The ladder is normally taken from the server (/v1/health -> tiers.granularities), and a server
   * that got that wrong is exactly how 1-minute bars came unlocked on BTC. So the health payload is
   * ORed with this list: the server can ADD a lock but never remove one. Never a substitute for the
   * server check — a UI lock is a lock on the honest — but a stale payload cannot reopen 1m here. */
  var PRO_BUCKETS = { tick: 1, '1m': 1, '3M': 1 };
  function isProBucket(v) { return !!PRO_BUCKETS[v]; }
  /* The padlock's words. It names the free ceiling rather than only the price, because "part of the
     subscription" does not tell somebody what they already have. */
  var LOCK_COPY = 'Free goes down to 5-minute bars — 1m and Tick are part of the $20/month subscription';
  var FREE_FLOOR_COPY = 'the free tier serves 5-minute bars and coarser';
  var RANGE_LOCK_COPY = '3 months of history is part of the $20/month subscription';
  /* seconds/label/pro mirror the API's own ladder; this copy is the cold-start fallback and
     /v1/health overwrites it — except `pro`, which is ORed with PRO_BUCKETS above.
     FINEST FIRST, which is also the order the chips are drawn in. `sec` is what sorts them; tick
     sorts first despite sec 0 because it is the finest thing the product has. */
  var INTERVALS = [
    { v: 'tick', label: 'Every tick', short: 'Tick', sec: 0, pro: true, maxDays: 7 },
    { v: '1m', label: '1 minute intervals', short: '1m', sec: 60, pro: true, maxDays: 31 },
    { v: '5m', label: '5 minute intervals', short: '5m', sec: 300, maxDays: 92 },
    { v: '15m', label: '15 minute intervals', short: '15m', sec: 900, maxDays: 92 },
    { v: '1h', label: '1 hour intervals', short: '1h', sec: 3600, maxDays: 92 },
    { v: '1d', label: '1 day intervals', short: '1d', sec: 86400, maxDays: 92 },
    { v: '3M', label: '3 month intervals', short: '3M', sec: 7776000, pro: true, maxDays: 1100 }
  ];
  function intervalOrder() { return INTERVALS.slice().sort(function (a, b) { return (a.sec || -1) - (b.sec || -1); }); }
  function interval(v) { for (var i = 0; i < INTERVALS.length; i++) if (INTERVALS[i].v === v) return INTERVALS[i]; return interval1d(); }
  function interval1d() { for (var i = 0; i < INTERVALS.length; i++) if (INTERVALS[i].v === '1d') return INTERVALS[i]; return INTERVALS[INTERVALS.length - 1]; }
  function rangeDef(v) { for (var i = 0; i < RANGES.length; i++) if (RANGES[i].v === v) return RANGES[i]; return RANGES[2]; }

  var FF = window.FF = {
    tab: 'episodes', venue: 'kalshi', mode: 'line', range: '30d', bucket: '1d', side: 'both', band: 'all', metric: 'trades',
    category: '', series: '', customFrom: '', customTo: '',
    up: null, retryMs: 5000, retryTimer: null, retryCountdown: null,
    token: null, ws: null, lastAsk: null
  };
  try { FF.token = localStorage.getItem('tff_token') || null; } catch (e) {}

  /* ------------------------------------------------------------------ account session state
     ONE source of truth for who is signed in. The ACCESS token is memory-only and never touches
     localStorage; only the refresh token is stored at rest, and it rotates on every use.
     `FF.token` is the LEGACY per-device Pro token and keeps working exactly as before — an account
     is an addition, not a replacement. */
  var AUTH = FF.auth = {
    providers: null,  /* GET /v1/auth/providers, fetched once per page load */
    access: null,     /* in-memory access token (15 min) — NEVER persisted */
    accessExp: 0,
    refresh: null,    /* localStorage.tff_refresh — the only thing stored at rest */
    sessionId: null,
    user: null,       /* {id,email,display_name,passkeys,…} */
    ent: null,        /* {pro,source,status,current_period_end,…} */
    sessions: [],     /* me.sessions — the device list */
    open: false,      /* is the account panel expanded */
    ready: null,      /* promise: the initial restore has been attempted */
    note: ''          /* a one-line status shown in the panel */
  };
  try { AUTH.refresh = localStorage.getItem('tff_refresh') || null; } catch (e) {}
  function signedIn() { return !!(AUTH.access && AUTH.user); }
  function proActive() { return !!FF.token || !!(AUTH.ent && AUTH.ent.pro); }

  /* ------------------------------------------------------------------ helpers */
  function $(id) { return document.getElementById(id); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function fmtN(n) { n = Number(n) || 0; if (Math.abs(n) >= 1e9) return (n / 1e9).toFixed(2) + 'B'; if (Math.abs(n) >= 1e6) return (n / 1e6).toFixed(2) + 'M'; if (Math.abs(n) >= 1e4) return (n / 1e3).toFixed(1) + 'k'; return n.toLocaleString(); }
  function fmtUSD(n) { n = Number(n) || 0; return (n < 0 ? '-' : '') + '$' + fmtN(Math.abs(n)); }
  function fmtPST(iso) { try { return new Date(iso).toLocaleString('en-US', { timeZone: 'America/Los_Angeles', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' }); } catch (e) { return String(iso); } }
  function fmtDay(iso) { try { return new Date(iso).toLocaleDateString('en-US', { timeZone: 'America/Los_Angeles', month: 'short', day: 'numeric' }); } catch (e) { return String(iso).slice(0, 10); } }
  function fmtDayISO(d) { return d.toISOString().slice(0, 10); }
  /* The window the controls currently describe, as real instants. Custom is inclusive of its end day. */
  function windowOf() {
    var r = rangeDef(FF.range);
    if (r.custom) {
      var f = FF.customFrom ? new Date(FF.customFrom + 'T00:00:00Z') : new Date(Date.now() - 7 * 86400000);
      var t = FF.customTo ? new Date(FF.customTo + 'T23:59:59Z') : new Date();
      if (f > t) { var s = f; f = t; t = s; }
      return { from: f, to: t, days: Math.max(1, Math.round((t - f) / 86400000)) };
    }
    var to = new Date();
    return { from: new Date(to.getTime() - r.days * 86400000), to: to, days: r.days };
  }
  /* The request window + the bucket to ask for. The bucket is FF.bucket — the visitor's Interval
     chip — and is no longer derived from the range by a hardcoded ternary. */
  function rangeDates() {
    var w = windowOf();
    return { from: w.from.toISOString(), to: w.to.toISOString(), fromMs: w.from.getTime(), toMs: w.to.getTime(), bucket: FF.bucket, days: w.days };
  }
  function scope() { var o = {}; if (FF.series) o.series = FF.series; else if (FF.category) o.category = FF.category; return o; }
  function qs(o) { return Object.keys(o).filter(function (k) { return o[k] !== '' && o[k] != null; }).map(function (k) { return encodeURIComponent(k) + '=' + encodeURIComponent(o[k]); }).join('&'); }

  /* in-flight request dedupe, keyed by method+path+body: a second caller asking for the exact same
     request while one is already in flight gets the SAME promise instead of firing a second fetch. */
  var PENDING = {};
  function reqKey(path, opts) { return (opts.method || (opts.body ? 'POST' : 'GET')) + ' ' + path + (opts.body ? ' ' + JSON.stringify(opts.body) : '') + (opts.bearer ? ' #' + String(opts.bearer).slice(-10) : ''); }
  function api(path, opts) {
    opts = opts || {};
    var key = reqKey(path, opts);
    if (PENDING[key]) return PENDING[key];
    var headers = { 'Accept': 'application/json' };
    if (opts.body) headers['Content-Type'] = 'application/json';
    if (opts.bearer) headers['Authorization'] = 'Bearer ' + opts.bearer;
    function attempt(base, remaining) {
      var c = new AbortController();
      var to = setTimeout(function () { c.abort(); }, opts.timeout || 9000);
      return fetch(base + path, { method: opts.method || (opts.body ? 'POST' : 'GET'), headers: headers, body: opts.body ? JSON.stringify(opts.body) : undefined, signal: c.signal, mode: 'cors' })
        .then(function (r) {
          clearTimeout(to);
          useBase(base);
          /* A 401 only forgets a LEGACY device token (that token really is dead). An account access
             token that 401s is merely expired — authFetch() refreshes and retries it. */
          if (r.status === 401 && opts.legacyAuth) { setToken(null); }
          if (!r.ok) {
            var retryAfter = null; try { retryAfter = r.headers.get('Retry-After'); } catch (x) {}
            return r.text().then(function (t) { var d = ''; try { d = JSON.parse(t).error || ''; } catch (x) {} var e = new Error('HTTP ' + r.status + (d ? ': ' + d : '')); e.status = r.status; e.detail = d; e.retryAfter = retryAfter ? parseFloat(retryAfter) : null; throw e; });
          }
          return r.json();
        })
        .catch(function (e) {
          clearTimeout(to);
          /* network-level failure (DNS, TLS, refused, timeout) -> try the next host once */
          if (!e.status && remaining.length) return attempt(remaining[0], remaining.slice(1));
          throw e;
        });
    }
    var p = attempt(API, API_BASES.filter(function (b) { return b !== API; }))
      .then(function (v) { delete PENDING[key]; return v; }, function (e) { delete PENDING[key]; throw e; });
    PENDING[key] = p;
    return p;
  }
  function errText(e) { return e && e.status ? ('HTTP ' + e.status + (e.detail ? ' \u2014 ' + e.detail : '')) : 'data service warming up'; }
  function setToken(t) { FF.token = t; try { t ? localStorage.setItem('tff_token', t) : localStorage.removeItem('tff_token'); } catch (e) {} renderPro(); renderAccount(); }

  /* ------------------------------------------------------------------ account: session plumbing
     authFetch() is the ONLY way an authenticated request is made. It picks the best bearer it has —
     an account access token first, the legacy device token otherwise — and on a 401 from an account
     token it refreshes ONCE and retries. If the refresh fails the session is over: sign out and
     re-render rather than leaving a half-signed-in UI. */
  function shallow(o) { var c = {}, k; for (k in (o || {})) if (Object.prototype.hasOwnProperty.call(o, k)) c[k] = o[k]; return c; }
  function authFetch(path, opts) {
    if (AUTH.access) {
      var a1 = shallow(opts); a1.bearer = AUTH.access;
      return api(path, a1).catch(function (e) {
        if (!e || e.status !== 401) throw e;
        return refreshSession().then(function () {
          var a2 = shallow(opts); a2.bearer = AUTH.access;
          return api(path, a2);
        }, function () { signOut({ local: true, note: 'Your session expired — please sign in again.' }); throw e; });
      });
    }
    if (FF.token) { var l = shallow(opts); l.bearer = FF.token; l.legacyAuth = true; return api(path, l); }
    return api(path, shallow(opts));
  }

  /* The refresh token ROTATES and the old one dies the instant the new one is minted, so two
     concurrent refreshes would kill each other. Single-flight, always. */
  var refreshInFlight = null, renewTimer = null;
  function refreshSession() {
    if (refreshInFlight) return refreshInFlight;
    if (!AUTH.refresh) return Promise.reject(new Error('no refresh token'));
    refreshInFlight = api('/v1/auth/refresh', { body: { refresh_token: AUTH.refresh }, timeout: 12000 })
      .then(function (s) { refreshInFlight = null; adoptSession(s); return s; },
            function (e) { refreshInFlight = null; throw e; });
    return refreshInFlight;
  }
  function adoptSession(s) {
    if (!s || !s.access_token) throw new Error('not a session response');
    AUTH.access = s.access_token;
    AUTH.accessExp = Date.now() + (Number(s.expires_in) || 900) * 1000;
    if (s.refresh_token) { AUTH.refresh = s.refresh_token; try { localStorage.setItem('tff_refresh', s.refresh_token); } catch (e) {} }
    if (s.session_id) AUTH.sessionId = s.session_id;
    if (s.user && AUTH.user && s.user.id !== AUTH.user.id) window.dispatchEvent(new Event('ffmail-reset'));
    if (s.user) AUTH.user = s.user;
    if (s.entitlement) AUTH.ent = s.entitlement;
    /* Renew a minute before expiry so a long-open tab keeps a usable token for the live socket.
       A throttled background timer is fine: the 401-then-refresh path is the real safety net. */
    clearTimeout(renewTimer);
    var ms = Math.max(30000, (AUTH.accessExp - Date.now()) - 60000);
    renewTimer = setTimeout(function () { if (AUTH.refresh) refreshSession().catch(function () {}); }, ms);
    return s;
  }
  function forgetSession() {
    AUTH.access = null; AUTH.accessExp = 0; AUTH.refresh = null; AUTH.sessionId = null;
    AUTH.user = null; AUTH.ent = null; AUTH.sessions = [];
    window.ffWebsiteAdminChanged(false);
    window.dispatchEvent(new Event("tff-account-changed"));
    clearTimeout(renewTimer);
    devCode = null; devCodeExp = 0; clearInterval(devTick);
    try { localStorage.removeItem('tff_refresh'); } catch (e) {}
    if (FF.owner) setOwner(false);
  }
  function signOut(o) {
    window.dispatchEvent(new Event('ffmail-reset'));
    o = o || {};
    var rt = AUTH.refresh;
    forgetSession();
    AUTH.note = o.note || '';
    /* Best effort: tell the server this refresh token is done with. Never block the UI on it. */
    if (rt && !o.local) api('/v1/auth/logout', { body: { refresh_token: rt }, timeout: 8000 }).catch(function () {});
    renderAccount(); renderPro();
  }
  /* GET /v1/me is what fills in the device list and the authoritative entitlement. */
  /* owner 2026-09-28: the market-data section is the OWNER's alone. `owner` comes from /v1/me, where
     tffapi computes it; nothing here decides it. Anybody else gets a site where it never existed:
     html.ff-owner gates every .ff-owner-only element, and a predictions view goes to the episodes. */
  var ownerPending = null;
  function setOwner(v) {
    FF.owner = !!v;
    document.documentElement.classList.toggle('ff-owner', FF.owner);
    if (!FF.owner) { ownerPending = null; if (FF.tab === 'predictions') window.ffShowTab('episodes'); return; }
    if (ownerPending) { var o = ownerPending; ownerPending = null; window.ffShowTab('predictions', o); }
  }
  window.ffIsOwner = function () { return !!FF.owner; };
  function loadMe() {
    return authFetch('/v1/me', { timeout: 12000 }).then(function (me) {
      if (!me) return me;
      setOwner(me.owner);
      window.ffWebsiteAdminChanged(!!me.admin);
      window.dispatchEvent(new Event("tff-account-changed"));
      if (me.user) AUTH.user = me.user;
      if (me.entitlement) AUTH.ent = me.entitlement;
      AUTH.sessions = me.sessions || [];
      renderAccount(); renderPro();
      return me;
    });
  }
  /* A brand-new sign-in: adopt it, move any legacy purchase onto the account, then read /v1/me. */
  function afterSignIn(s) {
    adoptSession(s);
    AUTH.note = '';
    renderAccount(); renderPro();
    return claimLegacyToken().then(loadMe, loadMe);
  }
  /* If this browser still holds a device tff_token, the purchase behind it belongs to the person who
     just signed in. Claiming is idempotent and leaves the old key in place — it keeps working. */
  function claimLegacyToken() {
    if (!FF.token || !signedIn()) return Promise.resolve(null);
    return authFetch('/v1/auth/claim', { body: { tff_token: FF.token }, timeout: 12000 })
      .then(function (r) { if (r && r.entitlement) AUTH.ent = r.entitlement; return r; })
      .catch(function () { return null; });  /* 404 unknown token / 409 already claimed: nothing to do */
  }

  /* ------------------------------------------------------------------ account: base64url <-> bytes
     WebAuthn speaks ArrayBuffers; this API speaks base64url with NO padding, both directions. */
  function b64uToBuf(s) {
    s = String(s == null ? '' : s).replace(/-/g, '+').replace(/_/g, '/');
    while (s.length % 4) s += '=';
    var bin = atob(s), n = bin.length, out = new Uint8Array(n);
    for (var i = 0; i < n; i++) out[i] = bin.charCodeAt(i);
    return out;
  }
  function bufToB64u(buf) {
    if (buf == null) return null;
    var b = (buf instanceof Uint8Array) ? buf : new Uint8Array(buf);
    var s = '', CH = 0x8000;  /* chunked so a large attestationObject cannot blow the arg limit */
    for (var i = 0; i < b.length; i += CH) s += String.fromCharCode.apply(null, b.subarray(i, i + CH));
    return btoa(s).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }

  /* ------------------------------------------------------------------ account: providers + handoff */
  var RP_ID = 'thefuturefiles.com';  /* the WEBSITE's relying party; the apps use api.thefuturefiles.com */
  function returnURL() { return window.location.origin + window.location.pathname + '?tab=predictions'; }
  function deviceName() {
    var ua = navigator.userAgent || '';
    var os = /iPhone|iPad/.test(ua) ? 'iOS' : /Macintosh/.test(ua) ? 'Mac' : /Windows/.test(ua) ? 'Windows' : /Android/.test(ua) ? 'Android' : /Linux/.test(ua) ? 'Linux' : '';
    var br = /Edg\//.test(ua) ? 'Edge' : /OPR\//.test(ua) ? 'Opera' : /Chrome\//.test(ua) ? 'Chrome' : /Firefox\//.test(ua) ? 'Firefox' : /Safari\//.test(ua) ? 'Safari' : 'Browser';
    return (br + (os ? ' on ' + os : '')).slice(0, 40);
  }
  /* Asked for once and cached for the tab. A provider whose console step is not done reports
     enabled:false and we draw NOTHING for it — a dead button is worse than no button. If the whole
     call fails (an older backend that has no accounts yet) the account UI stays hidden entirely. */
  function loadProviders() {
    if (AUTH.providers) return Promise.resolve(AUTH.providers);
    try {
      var c = JSON.parse(sessionStorage.getItem('tff_providers2') || 'null');
      if (c && c.at && (Date.now() - c.at) < 600000 && c.p) { AUTH.providers = c.p; return Promise.resolve(c.p); }
    } catch (e) {}
    return api('/v1/auth/providers', { timeout: 9000 }).then(function (p) {
      AUTH.providers = p || {};
      try { sessionStorage.setItem('tff_providers2', JSON.stringify({ at: Date.now(), p: AUTH.providers })); } catch (e) {}
      return AUTH.providers;
    });
  }
  function prov(name) { return (AUTH.providers && AUTH.providers[name]) || null; }

  /* A browser redirect flow (Apple's form_post, the email magic link) finishes on the API host, so it
     cannot write into this origin's storage. It bounces back with a one-time code in the URL
     FRAGMENT — never the query, so it stays out of server logs and Referer headers — and we trade it
     for a session, then strip it from the URL so it cannot be reused or copy-pasted. */
  function takeHandoff() {
    var h = window.location.hash || '';
    if (h.length < 2 || h.indexOf('auth_') < 0) return null;
    var p;
    try { p = new URLSearchParams(h.slice(1)); } catch (e) { return null; }
    var code = p.get('auth_code'), err = p.get('auth_error');
    if (!code && !err) return null;
    p.delete('auth_code'); p.delete('auth_error');
    var rest = p.toString();
    try { history.replaceState(null, '', window.location.pathname + (window.location.search || '') + (rest ? '#' + rest : '')); } catch (e) {}
    return { code: code || null, error: err || null };
  }

  /* ------------------------------------------------------------------ account: the four methods */
  function signInApple() {
    var p = prov('apple'); if (!p || !p.web) return;
    var url = API + '/v1/auth/apple/start?client=web&return=' + encodeURIComponent(returnURL());
    /* 10-02 playthrough: while an episode plays, sign in in a pop-up so this page (and the audio) stays. */
    var au = $('audioElement');
    if (au && au.src && !au.paused) { var w = window.open(url, 'tffsignin', 'popup,width=520,height=720'); if (w) return; }
    window.location.href = url;
  }
  /* The pop-up's return page calls this on its opener with the one-time handoff code, then closes. */
  window.ffAuthHandoff = function (code) {
    return api('/v1/auth/handoff', { body: { code: code, client: 'web', device: deviceName() }, timeout: 15000 })
      .then(afterSignIn).then(function () { renderAccount(); renderPro(); })
      .catch(function () { AUTH.note = 'That sign-in link has expired — please try again.'; AUTH.open = true; renderAccount(); });
  };

  function passkeySupported() { return !!(window.PublicKeyCredential && navigator.credentials && navigator.credentials.get); }
  function signInPasskey() {
    var hint = ($('ffAcctEmail') && $('ffAcctEmail').value.trim()) || '';
    acctBusy('ffPkBtn', 'Waiting for your passkey…');
    return api('/v1/auth/webauthn/login/options', { body: { rp_id: RP_ID, email: hint, client: 'web' }, timeout: 12000 })
      .then(function (o) {
        var pk = (o && o.publicKey) || {};
        return navigator.credentials.get({
          publicKey: {
            challenge: b64uToBuf(pk.challenge),
            rpId: pk.rpId || pk.rp_id || (o && o.rp_id) || RP_ID,
            timeout: pk.timeout || 120000,
            userVerification: pk.userVerification || 'preferred',
            allowCredentials: (pk.allowCredentials || []).map(function (c) {
              return { type: c.type || 'public-key', id: b64uToBuf(c.id) };
            })
          }
        });
      })
      .then(function (cred) {
        if (!cred) throw new Error('no credential');
        var r = cred.response, body = {
          id: cred.id, raw_id: bufToB64u(cred.rawId), type: cred.type, client: 'web', device: deviceName(),
          response: {
            client_data_json: bufToB64u(r.clientDataJSON),
            authenticator_data: bufToB64u(r.authenticatorData),
            signature: bufToB64u(r.signature)
          }
        };
        var uh = bufToB64u(r.userHandle); if (uh) body.response.user_handle = uh;
        return api('/v1/auth/webauthn/login/verify', { body: body, timeout: 15000 });
      })
      .then(afterSignIn)
      .catch(function (e) { acctFail(e, 'Passkey sign-in did not complete'); });
  }
  /* Adding a passkey to an account already signed in — this is what makes the NEXT sign-in one tap. */
  function addPasskey() {
    if (!signedIn()) return;
    acctBusy('ffAddPk', 'Follow your device’s prompt…');
    return authFetch('/v1/auth/webauthn/register/options', { body: { rp_id: RP_ID, label: deviceName(), client: 'web' }, timeout: 12000 })
      .then(function (o) {
        var pk = (o && o.publicKey) || {}, u = pk.user || {};
        return navigator.credentials.create({
          publicKey: {
            challenge: b64uToBuf(pk.challenge),
            rp: pk.rp || { id: RP_ID, name: 'The Future Files' },
            user: { id: b64uToBuf(u.id), name: u.name || '', displayName: u.displayName || u.name || '' },
            pubKeyCredParams: pk.pubKeyCredParams || [{ type: 'public-key', alg: -7 }, { type: 'public-key', alg: -257 }],
            timeout: pk.timeout || 120000,
            attestation: pk.attestation || 'none',
            authenticatorSelection: pk.authenticatorSelection || { residentKey: 'preferred', userVerification: 'preferred' },
            excludeCredentials: (pk.excludeCredentials || []).map(function (c) { return { type: c.type || 'public-key', id: b64uToBuf(c.id) }; })
          }
        });
      })
      .then(function (cred) {
        if (!cred) throw new Error('no credential');
        var tr = null; try { tr = cred.response.getTransports ? cred.response.getTransports() : null; } catch (e) {}
        return authFetch('/v1/auth/webauthn/register/verify', {
          body: {
            id: cred.id, raw_id: bufToB64u(cred.rawId), type: cred.type, label: deviceName(), rp_id: RP_ID,
            transports: tr || undefined,
            response: { client_data_json: bufToB64u(cred.response.clientDataJSON), attestation_object: bufToB64u(cred.response.attestationObject) }
          }, timeout: 15000
        });
      })
      .then(function () { AUTH.note = 'Passkey added to this device.'; return loadMe(); })
      .catch(function (e) { acctFail(e, 'That passkey was not added'); });
  }

  function signInEmail() {
    var el = $('ffAcctEmail'), em = el ? el.value.trim() : '';
    if (!em || em.indexOf('@') < 1) { AUTH.note = 'Enter your email address first.'; renderAccount(); return; }
    acctBusy('ffEmailBtn', 'Sending…');
    return api('/v1/auth/email/start', { body: { email: em, client: 'web', return: returnURL() }, timeout: 15000 })
      .then(function () {
        try { sessionStorage.setItem('tff_email_pending', em); } catch (e) {}
        AUTH.note = 'Check your email — we sent a sign-in link to ' + em + ' (and an 8-character code you can type below).';
        renderAccount();
      })
      .catch(function (e) { acctFail(e, e && e.status === 503 ? 'Email sign-in is not switched on yet' : 'That email could not be sent'); });
  }
  function verifyEmailCode() {
    var em = ($('ffAcctEmail') && $('ffAcctEmail').value.trim()) || '';
    try { em = em || sessionStorage.getItem('tff_email_pending') || ''; } catch (e) {}
    var code = ($('ffAcctCode') && $('ffAcctCode').value.trim()) || '';
    if (!em || !code) { AUTH.note = 'Enter your email and the 8-character code.'; renderAccount(); return; }
    acctBusy('ffCodeBtn', 'Checking…');
    return api('/v1/auth/email/verify', { body: { email: em, code: code, client: 'web', device: deviceName() }, timeout: 15000 })
      .then(afterSignIn)
      .catch(function (e) { acctFail(e, 'That code was not accepted'); });
  }

  /* Google Identity Services renders its own button, so the script is only loaded once we know the
     client id from /v1/auth/providers. Nothing is loaded from Google when it is not configured. */
  var gsiLoading = null;
  function loadGSI() {
    if (window.google && window.google.accounts && window.google.accounts.id) return Promise.resolve();
    if (gsiLoading) return gsiLoading;
    gsiLoading = new Promise(function (res, rej) {
      var s = document.createElement('script');
      s.src = 'https://accounts.google.com/gsi/client'; s.async = true; s.defer = true;
      s.onload = function () { res(); }; s.onerror = function () { gsiLoading = null; rej(new Error('gsi')); };
      document.head.appendChild(s);
    });
    return gsiLoading;
  }
  function mountGoogle() {
    var host = $('ffGBtn'); if (!host) return;
    var g = prov('google'); if (!g || !g.enabled) return;
    var cid = (g.client_ids && g.client_ids[0]) || g.client_id; if (!cid) return;
    loadGSI().then(function () {
      host.hidden = false;
      var gw = Math.round(host.getBoundingClientRect().width) || 0, gText = (PW.mode === 'up' && host.classList.contains('ff-si-gbtn')) ? 'signup_with' : 'signin_with';
      gw = gw >= 200 ? Math.min(400, gw) : 260;
      if (host.dataset.mounted === cid + '|' + gText + '|' + gw) return;
      host.dataset.mounted = cid + '|' + gText + '|' + gw;
      window.google.accounts.id.initialize({
        client_id: cid,
        callback: function (resp) {
          if (!resp || !resp.credential) return;
          api('/v1/auth/google', { body: { credential: resp.credential, client: 'web', device: deviceName() }, timeout: 15000 })
            .then(afterSignIn).catch(function (e) { acctFail(e, 'Google sign-in did not complete'); });
        }
      });
      window.google.accounts.id.renderButton(host, { theme: 'filled_black', size: 'large', shape: 'pill', text: gText, width: gw, logo_alignment: 'left' });
    }).catch(function () { host.hidden = true; });
  }

  /* ------------------------------------------------------------------ account: signed-in actions */
  function saveDisplayName() {
    var el = $('ffAcctName'); if (!el || !signedIn()) return;
    var v = el.value.trim();
    acctBusy('ffNameSave', 'Saving…');
    return authFetch('/v1/me', { body: { display_name: v }, timeout: 12000 })
      .then(function (r) { if (r && r.user) AUTH.user = r.user; AUTH.note = 'Name saved.'; renderAccount(); })
      .catch(function (e) { acctFail(e, 'That name could not be saved'); });
  }
  /* A code the visitor carries to another device. A desktop app served from http://127.0.0.1:<port>
     has no web origin Apple or Google will redirect to, so the website — which CAN sign in — is where
     the code is minted. Single-use, 10 minutes, held in memory only: never stored, never in the URL. */
  var devCode = null, devCodeExp = 0, devTick = null;
  function getDeviceCode() {
    if (!signedIn()) return;
    acctBusy('ffDevCode', 'Minting a code…');
    return authFetch('/v1/auth/handoff/create', { body: { device: deviceName() }, timeout: 12000 })
      .then(function (r) {
        if (!r || !r.code) throw new Error('no code returned');
        devCode = r.code;
        devCodeExp = Date.now() + (Number(r.expires_in) || 600) * 1000;
        AUTH.note = '';
        renderAccount();
      })
      .catch(function (e) { devCode = null; acctFail(e, 'That code could not be created'); });
  }
  function devCodeHtml() {
    if (!devCode) return '';
    return '<div class="ff-devcode"><div class="ff-devcode-v" id="ffDevCodeV">' + esc(devCode) + '</div>' +
      '<button class="ff-acct-rev" id="ffDevCopy">Copy</button>' +
      '<div class="ff-muted ff-devcode-t">Type this into the sign-in panel of the other app. It works once and lasts 10 minutes. <span id="ffDevCodeLeft"></span></div></div>';
  }
  /* The countdown stops at "expired" and offers the button again rather than running negative. */
  function startDevCountdown() {
    clearInterval(devTick);
    var out = $('ffDevCodeLeft'); if (!out || !devCode) return;
    var paint = function () {
      var el = $('ffDevCodeLeft'); if (!el) { clearInterval(devTick); return; }
      var ms = devCodeExp - Date.now();
      if (ms <= 0) { clearInterval(devTick); devCode = null; AUTH.note = 'That code expired — get another one.'; renderAccount(); return; }
      var s = Math.floor(ms / 1000);
      el.textContent = 'Expires in ' + Math.floor(s / 60) + ':' + String(s % 60).padStart(2, '0') + '.';
    };
    paint(); devTick = setInterval(paint, 1000);
  }
  function copyDeviceCode() {
    var b = $('ffDevCopy'); if (!devCode) return;
    var flash = function () { if (!b) return; var t = b.textContent; b.textContent = 'Copied'; setTimeout(function () { if (b) b.textContent = t; }, 1400); };
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(devCode).then(flash, function () {});
    } catch (e) {}  /* no clipboard (http, older browser, denied): the code is on screen to read */
  }
  function revokeSession(id) {
    if (!id || !signedIn()) return;
    var mine = AUTH.sessionId === id;
    return authFetch('/v1/auth/sessions/revoke', { body: { session_id: id }, timeout: 12000 })
      .then(function () {
        if (mine) { signOut({ local: true, note: 'Signed out of this browser.' }); return; }
        AUTH.note = 'That device was signed out.'; return loadMe();
      })
      .catch(function (e) { acctFail(e, 'That device could not be signed out'); });
  }
  function useTypedToken() {
    var el = $('ffTokenIn'); if (!el) return;
    var t = el.value.trim(); if (!t) return;
    setToken(t);
    if (signedIn()) claimLegacyToken().then(loadMe, function () {});
  }

  /* ------------------------------------------------------------------ account: rendering */
  function acctBusy(id, label) { var b = $(id); if (b) { b.disabled = true; b.textContent = label; } AUTH.note = ''; }
  function acctFail(e, what) {
    /* A user who dismisses the platform passkey sheet is not an error worth shouting about. */
    var name = e && e.name;
    if (name === 'NotAllowedError' || name === 'AbortError') AUTH.note = 'Cancelled.';
    else AUTH.note = what + ' — ' + (e && e.status ? errText(e) : (e && e.message) || 'please try again');
    renderAccount();
  }
  function entLine() {
    var e = AUTH.ent || {};
    if (!e.pro) return 'Free';
    var end = e.current_period_end ? fmtDay(e.current_period_end) : '';
    if (/cancel/i.test(String(e.status || '')) && end) return 'Pro — ends ' + end;
    if (e.source === 'stripe' && end) return 'Pro — renews ' + end;
    if (e.source === 'claimed_token') return 'Pro — claimed purchase' + (end ? ', renews ' + end : '');
    return 'Pro — granted';
  }
  /* R14-61: a password account's address is not verified, so it is never the account's own email (tffapi auth_password.go); the address it
     signs in with is on its identity — show that one. */
  function acctEmail(u) {
    u = u || {};
    if (u.email) return u.email;
    var ids = u.identities || [];
    for (var i = 0; i < ids.length; i++) if (ids[i] && ids[i].email) return ids[i].email;
    return '';
  }
  function acctInitial() {
    var u = AUTH.user || {};
    var s = (u.display_name || acctEmail(u) || '?').trim();
    return (s.charAt(0) || '?').toUpperCase();
  }
  function anyProvider() {
    if (!AUTH.providers) return false;
    var a = prov('apple'), g = prov('google'), e = prov('email'), p = prov('passkey');
    var pw = prov('password');
    return !!((a && a.web) || (g && g.enabled) || (e && e.enabled) || (pw && pw.enabled) || (p && p.enabled && passkeySupported()));
  }
  /* 10-20: the header circle and the drawer's Sign in / Sign out row follow every change of the account state */
  function renderAccount() { try { renderAccount0(); } finally { try { if (window.ffAcctCircleSync) window.ffAcctCircleSync(); window.dispatchEvent(new Event('ffaccount')); } catch (e) {} } }
  function renderAccount0() {
    var btn = $('ffAcctBtn'), panel = $('ffAcctPanel');
    if (!btn || !panel) return;
    /* No accounts backend (or no provider at all) -> the site behaves exactly as it did before. */
    if (!AUTH.providers || (!signedIn() && !anyProvider())) { btn.hidden = true; panel.hidden = true; return; }
    btn.hidden = false;
    if (signedIn()) {
      var u = AUTH.user || {};
      btn.innerHTML = '<span class="ff-acct-av">' + esc(acctInitial()) + '</span><span class="ff-acct-who">' + esc(u.display_name || u.email || 'Account') + '</span>';
      btn.title = 'Your account';
    } else {
      btn.innerHTML = '<i class="fas fa-user"></i><span class="ff-acct-who">Sign in</span>';
      btn.title = 'Sign in to The Future Files';
    }
    panel.hidden = !AUTH.open;
    if (!AUTH.open) return;
    panel.innerHTML = signedIn() ? acctInHtml() : acctOutHtml();
    wireAccount();
  }
  /* R14-61 (10-21, operator: "make it look more professional … remove the 8-character code and the email me a link sign in so that there's an
     actual way to sign in with your email and password … center the sign in with Google and Apple and Passkey"): the logo, "Sign in", the
     three providers as one centred set, "or", then e-mail + password — sign in, or create an account. Without a backend that has password
     sign-in (providers.password) the earlier panel (acctOutHtmlOld) is drawn instead. */
  var PW = { mode: 'in', email: '' };
  function acctInDialog() { var pn = $('ffAcctPanel'); return !!(pn && pn.parentNode && pn.parentNode.id === 'ffAcctDialog'); }
  function acctOutHtml() {
    var pw = prov('password');
    if (!pw || !pw.enabled) return acctOutHtmlOld();
    var a = prov('apple'), g = prov('google'), p = prov('passkey'), up = PW.mode === 'up', min = pw.min_length || 8;
    var logo = document.querySelector('img[src*="logo2."]');
    var h = '<div class="ff-si">' +
      (acctInDialog() ? '<button type="button" class="ff-si-x" id="ffAcctClose" aria-label="Close">&times;</button>' : '') +
      (logo ? '<img class="ff-si-logo" src="' + esc(logo.getAttribute('src')) + '" alt="" aria-hidden="true">' : '') +
      '<h2 class="ff-si-title">' + (up ? 'Create your account' : 'Sign in') + '</h2>' +
      '<p class="ff-si-sub">One account for the website and the apps.</p>' +
      '<div class="ff-si-providers">';
    if (a && a.web) h += '<button type="button" class="ff-si-btn" id="ffAppleBtn"><span class="ff-si-ic" aria-hidden="true"><i class="fab fa-apple"></i></span>' + (up ? 'Sign up with Apple' : 'Sign in with Apple') + '</button>';
    if (g && g.enabled && ((g.client_ids && g.client_ids.length) || g.client_id)) h += '<div id="ffGBtn" class="ff-si-gbtn" hidden></div>';   /* shown once Google's button is drawn */
    if (!up && p && p.enabled && passkeySupported()) h += '<button type="button" class="ff-si-btn" id="ffPkBtn"><span class="ff-si-ic" aria-hidden="true"><i class="fas fa-fingerprint"></i></span>Sign in with a passkey</button>';
    h += '</div>' +
      '<div class="ff-si-sep"><span>or</span></div>' +
      '<form class="ff-si-form" id="ffPwForm" novalidate>' +
        '<label class="ff-si-field">Email<input id="ffAcctEmail" type="email" name="email" autocomplete="' + (up ? 'email' : 'username') + '" inputmode="email" autocapitalize="off" spellcheck="false" placeholder="you@example.com" value="' + esc(PW.email) + '"></label>' +
        '<label class="ff-si-field">Password<span class="ff-si-pw"><input id="ffAcctPw" type="password" name="password" autocomplete="' + (up ? 'new-password' : 'current-password') + '" placeholder="' + (up ? 'At least ' + min + ' characters' : 'Your password') + '">' +
          '<button type="button" class="ff-si-eye" id="ffPwEye" aria-label="Show password" aria-pressed="false"><i class="fas fa-eye" aria-hidden="true"></i></button></span></label>' +
        '<button type="submit" class="ff-si-submit" id="ffPwBtn">' + (up ? 'Create account' : 'Sign in') + '</button>' +
      '</form>';
    if (AUTH.note) h += '<div class="ff-si-note" role="alert">' + esc(AUTH.note) + '</div>';
    h += '<div class="ff-si-switch">' + (up ? 'Already have an account? <button type="button" class="ff-si-link" id="ffPwMode">Sign in</button>'
      : 'New to The Future Files? <button type="button" class="ff-si-link" id="ffPwMode">Create an account</button>') + '</div>';
    if (FF.owner) h += tokenBoxHtml();
    return h + '</div>';
  }
  /* a message under the form WITHOUT redrawing it (what was typed stays typed) */
  function pwNote(msg) {
    var f = $('ffPwForm'); if (!f) { AUTH.note = msg; renderAccount(); return; }
    var n = f.parentNode.querySelector('.ff-si-note');
    if (!msg) { if (n) n.parentNode.removeChild(n); return; }
    if (!n) { n = document.createElement('div'); n.className = 'ff-si-note'; n.setAttribute('role', 'alert'); f.parentNode.insertBefore(n, f.nextSibling); }
    n.textContent = msg;
  }
  function pwBusy(on) {
    var b = $('ffPwBtn'); if (!b) return;
    b.disabled = !!on;
    b.textContent = on ? (PW.mode === 'up' ? 'Creating your account…' : 'Signing in…') : (PW.mode === 'up' ? 'Create account' : 'Sign in');
  }
  function submitPassword(ev) {
    if (ev && ev.preventDefault) ev.preventDefault();
    var up = PW.mode === 'up', pw = prov('password') || {}, min = pw.min_length || 8;
    var emEl = $('ffAcctEmail'), pwEl = $('ffAcctPw');
    var em = ((emEl && emEl.value) || '').trim(), pass = (pwEl && pwEl.value) || '';
    PW.email = em;
    var bad = !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(em) ? 'Enter your email address.' : !pass ? 'Enter your password.'
      : (up && pass.length < min) ? 'Use at least ' + min + ' characters for your password.' : '';
    if (bad) { pwNote(bad); try { (bad.indexOf('email') >= 0 ? emEl : pwEl).focus(); } catch (e) {} return; }
    pwNote(''); pwBusy(true); AUTH.note = '';
    return api(up ? '/v1/auth/password/signup' : '/v1/auth/password/login', { body: { email: em, password: pass, client: 'web', device: deviceName() }, timeout: 20000 })
      .then(function (s) { PW.email = ''; PW.mode = 'in'; return afterSignIn(s); })
      .catch(function (e) {
        pwBusy(false);
        pwNote(e && e.detail ? e.detail : e && e.status === 429 ? 'Too many attempts. Please wait a few minutes and try again.'
          : e && e.status ? (up ? 'That account could not be created. Please try again.' : 'Email or password is incorrect.')
          : 'Sign-in is not available right now. Please try again in a moment.');
        var f = $('ffAcctPw'); if (f) try { f.focus(); f.select(); } catch (x) {}
      });
  }
  function togglePwMode() {
    var emEl = $('ffAcctEmail'); PW.email = emEl ? emEl.value.trim() : PW.email;
    PW.mode = PW.mode === 'up' ? 'in' : 'up';
    AUTH.note = '';
    renderAccount();
    var f = PW.email ? $('ffAcctPw') : $('ffAcctEmail'); if (f) try { f.focus({ preventScroll: true }); } catch (e) {}
  }
  function togglePwEye() {
    var i = $('ffAcctPw'), b = $('ffPwEye'); if (!i || !b) return;
    var show = i.type === 'password';
    i.type = show ? 'text' : 'password';
    b.setAttribute('aria-pressed', show ? 'true' : 'false');
    b.setAttribute('aria-label', show ? 'Hide password' : 'Show password');
    b.innerHTML = '<i class="fas ' + (show ? 'fa-eye-slash' : 'fa-eye') + '" aria-hidden="true"></i>';
    try { i.focus({ preventScroll: true }); } catch (e) {}
  }
  function acctOutHtmlOld() {
    var a = prov('apple'), g = prov('google'), e = prov('email'), p = prov('passkey');
    var h = '<div class="ff-card-head"><span><i class="fas fa-right-to-bracket"></i> Sign in</span>' +
      '<button class="ff-ask-x" id="ffAcctClose" title="Close">&times;</button></div>' +
      '<div class="ff-acct-intro">One account for the website and the apps.</div>' +
      '<div class="ff-signin">';
    if (a && a.web) h += '<button class="ff-signin-btn" id="ffAppleBtn"><i class="fab fa-apple"></i> Sign in with Apple</button>';
    if (g && g.enabled && ((g.client_ids && g.client_ids.length) || g.client_id)) h += '<div id="ffGBtn" class="ff-gbtn"></div>';
    if (p && p.enabled && passkeySupported()) h += '<button class="ff-signin-btn" id="ffPkBtn"><i class="fas fa-fingerprint"></i> Sign in with a passkey</button>';
    h += '</div>';
    if (e && e.enabled) {
      h += '<div class="ff-acct-sep"><span>or use your email</span></div>' +
        '<div class="ff-form ff-form-row ff-acct-mail"><label>Email<input id="ffAcctEmail" type="email" autocomplete="email" placeholder="you@example.com"></label>' +
        '<button class="ff-btn" id="ffEmailBtn">Email me a link</button></div>' +
        '<div class="ff-form ff-form-row ff-acct-mail"><label>Or the 8-character code from that email<input id="ffAcctCode" placeholder="XXXX-XXXX" autocomplete="one-time-code" maxlength="9"></label>' +
        '<button class="ff-btn ff-btn-ghost" id="ffCodeBtn">Use code</button></div>';
    } else if (p && p.enabled && passkeySupported()) {
      h += '<div class="ff-form ff-form-row ff-acct-mail"><label>Email (optional, helps your device pick the right passkey)<input id="ffAcctEmail" type="email" autocomplete="email" placeholder="you@example.com"></label></div>';
    }
    if (FF.owner) h += tokenBoxHtml();
    if (AUTH.note) h += '<div class="ff-acct-note">' + esc(AUTH.note) + '</div>';
    return h;
  }
  /* "I already have Pro, bought before accounts existed." One collapsed row, in the account panel
     rather than on the Pro card: it is not part of deciding to subscribe. */
  function tokenBoxHtml() {
    return '<details class="ff-tokenbox"><summary>Have a Pro token from an app?</summary>' +
      '<div class="ff-form ff-form-row"><label>Pro token<input id="ffTokenIn" placeholder="tff_…" autocomplete="off" spellcheck="false"></label>' +
      '<button class="ff-btn ff-btn-ghost" id="ffTokenUse">Use token</button></div>' +
      '<div class="ff-muted">Unlocks Pro in this browser. Signed in, it is attached to your account too, so you never paste it again.</div></details>';
  }
  function acctInHtml() {
    var u = AUTH.user || {}, p = prov('passkey');
    var h = (acctInDialog() ? '<button type="button" class="ff-si-x" id="ffAcctClose" aria-label="Close">&times;</button>' : '') +
      '<div class="ff-card-head"><span><i class="fas fa-user-check"></i> ' + esc(acctEmail(u) || 'Your account') + '</span>' +
      (FF.owner ? '<span class="ff-pro-tag' + (AUTH.ent && AUTH.ent.pro ? ' ff-pro-tag-on' : '') + '">' + esc(entLine()) + '</span>' : '') + '</div>' +
      '<div class="ff-form ff-form-row ff-acct-mail"><label>Display name<input id="ffAcctName" value="' + esc(u.display_name || '') + '" placeholder="Your name" maxlength="60"></label>' +
      '<button class="ff-btn ff-btn-ghost" id="ffNameSave">Save</button></div>' +
      '<div class="ff-acct-actions">' +
      (FF.owner ? '<button class="ff-btn ff-btn-ghost" id="ffAcctManage"><i class="fas fa-gear"></i> Manage subscription</button>' : '');
    if (p && p.enabled && window.PublicKeyCredential && navigator.credentials && navigator.credentials.create) {
      h += '<button class="ff-btn ff-btn-ghost" id="ffAddPk"><i class="fas fa-fingerprint"></i> Add a passkey</button>';
    }
    h += '<button class="ff-btn ff-btn-ghost" id="ffDevCode"><i class="fas fa-keyboard"></i> Get a code for another device</button>' +
      '<button class="ff-btn ff-btn-ghost" id="ffAcctOut"><i class="fas fa-right-from-bracket"></i> Sign out</button></div>' +
      devCodeHtml() +
      '<div id="ffAcctManageMsg" class="ff-muted"></div>';
    if (FF.owner) h += tokenBoxHtml();
    if ((u.passkeys || []).length) h += '<div class="ff-muted ff-acct-keys">' + u.passkeys.length + ' passkey' + (u.passkeys.length === 1 ? '' : 's') + ' on this account.</div>';
    var s = AUTH.sessions || [];
    if (s.length) {
      h += '<div class="ff-card-head ff-billing-head"><span><i class="fas fa-laptop"></i> Signed-in devices</span><span class="ff-muted">' + s.length + '</span></div><div class="ff-acct-devs">';
      s.forEach(function (x) {
        h += '<div class="ff-acct-dev"><div><b>' + esc(x.device || x.client || 'device') + '</b>' + (x.current ? ' <span class="ff-pro-tag ff-pro-tag-on">this one</span>' : '') +
          '<div class="ff-muted">' + esc(x.client || '') + ' · last used ' + esc(fmtPST(x.last_used)) + '</div></div>' +
          '<button class="ff-acct-rev" data-sid="' + esc(x.id) + '" title="Sign this device out">Revoke</button></div>';
      });
      h += '</div>';
    }
    if (AUTH.note) h += '<div class="ff-acct-note">' + esc(AUTH.note) + '</div>';
    return h;
  }
  function wireAccount() {
    var on = function (id, fn) { var el = $(id); if (el) el.addEventListener('click', fn); };
    on('ffAcctClose', function () { AUTH.open = false; renderAccount(); });
    on('ffAppleBtn', signInApple);
    on('ffPkBtn', signInPasskey);
    on('ffEmailBtn', signInEmail);
    on('ffCodeBtn', verifyEmailCode);
    var pwf = $('ffPwForm'); if (pwf) pwf.addEventListener('submit', submitPassword);
    on('ffPwMode', togglePwMode);
    on('ffPwEye', togglePwEye);
    on('ffNameSave', saveDisplayName);
    on('ffAddPk', addPasskey);
    on('ffDevCode', getDeviceCode);
    on('ffDevCopy', copyDeviceCode);
    on('ffAcctOut', function () { signOut({}); });
    startDevCountdown();
    on('ffAcctManage', function () { managePortal('ffAcctManage', 'ffAcctManageMsg'); });
    on('ffTokenUse', useTypedToken);
    var code = $('ffAcctCode'); if (code) code.addEventListener('keydown', function (ev) { if (ev.key === 'Enter') { ev.preventDefault(); verifyEmailCode(); } });
    var em = $('ffAcctEmail');
    if (em) { try { em.value = em.value || sessionStorage.getItem('tff_email_pending') || ''; } catch (e) {} }
    var panel = $('ffAcctPanel');
    if (panel) panel.querySelectorAll('.ff-acct-rev').forEach(function (b) { b.addEventListener('click', function () { revokeSession(b.dataset.sid); }); });
    mountGoogle();
  }
  function openAccount() {
    AUTH.open = true;
    loadProviders().then(renderAccount, renderAccount);
    renderAccount();
    var p = $('ffAcctPanel'); if (p && p.scrollIntoView) try { p.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) {}
  }
  window.ffOpenAccount = openAccount;
  /* The ☰ drawer needs the account panel to EXIST before it can host it, and on the episodes tab
     nothing has built the predictions shell yet. renderVenue() is idempotent (it guards on
     root.dataset.built), so calling it here costs one pass and never switches tabs. */
  window.ffEnsureAccount = function () { try { renderVenue(); } catch (e) {} };
  window.ffAccountSignedIn = function () { return signedIn(); };
  /* 10-02 the DVD tab (tff-discs.js) uses this page's account session: a bearer (renewed when it is
     close to expiry, or restored from the stored refresh token), and a sign-in made from the basket's
     email-code dialog is adopted here exactly as the account panel's own sign-in is. */
  window.ffAuthBearer = function () {
    if (AUTH.access && AUTH.accessExp - Date.now() > 60000) return Promise.resolve(AUTH.access);
    if (!AUTH.refresh) return Promise.resolve(null);
    return refreshSession().then(function () { return AUTH.access || null; }, function () { return null; });
  };
  window.ffAuthAdopt = function (s) { try { afterSignIn(s); } catch (e) {} };
  window.ffAccountName = function () { var u = AUTH.user || {}; return u.display_name || acctEmail(u) || 'Account'; };
  /* 10-20 (T099/T112): the header's account circle hosts the SAME panel in its popover (one set of element ids, as the drawer does); sign out from the drawer */
  window.ffAccountOpenIn = function (host) {
    window.ffEnsureAccount();
    var panel = document.getElementById('ffAcctPanel'); if (!panel || !host) return false;
    if (!acctHome) { acctHome = panel.parentNode; acctHomeNext = panel.nextSibling; }
    host.appendChild(panel);
    window.ffOpenAccount();
    return true;
  };
  window.ffAccountClose = function () { AUTH.open = false; renderAccount(); };
  window.ffAccountRelease = function () { acctToHome(); };
  window.ffSignOut = function () { signOut({}); };

  /* ---------------------------------------------------------------- account inside the ☰ drawer
     On a phone the account lives in the side drawer, not behind a pill in the Market Data header:
     one way in, reached from any tab. There is deliberately only ONE panel in the document — this
     MOVES #ffAcctPanel into the drawer and puts it back above 768px — because a second copy would
     duplicate every element id the sign-in flow wires by id (ffAcctEmail, ffPkBtn, ffAcctCode…)
     and `$()` would then bind the wrong one. */
  var acctHome = null;      /* where the panel lives on a wide window */
  var acctHomeNext = null;  /* its following sibling, so it goes back in the right place */
  function drawerAcctHost() { return document.getElementById('ffDrawerAcctHost'); }
  function acctToDrawer() {
    var panel = document.getElementById('ffAcctPanel'), host = drawerAcctHost();
    if (!panel || !host || panel.parentNode === host) return !!panel;
    if (!acctHome) { acctHome = panel.parentNode; acctHomeNext = panel.nextSibling; }
    host.appendChild(panel);
    return true;
  }
  function acctToHome() {
    var panel = document.getElementById('ffAcctPanel');
    if (!panel || !acctHome || panel.parentNode === acctHome) return;
    if (acctHomeNext && acctHomeNext.parentNode === acctHome) acctHome.insertBefore(panel, acctHomeNext);
    else acctHome.appendChild(panel);
  }
  window.ffDrawerAccount = function () {
    window.ffEnsureAccount();            /* builds the shell without switching tabs */
    if (!acctToDrawer()) return;
    window.ffOpenAccount();
  };
  /* The drawer row says who you are once you are signed in. */
  window.ffDrawerAcctSync = function () {
    var lab = document.getElementById('ffDrawerAcctLabel');
    if (lab) lab.textContent = window.ffAccountSignedIn() ? window.ffAccountName() : 'Sign in';
    var so = document.getElementById('drawer-signout'); if (so) so.hidden = !window.ffAccountSignedIn();
    if (window.matchMedia('(min-width: 768px)').matches) acctToHome();
  };
  window.addEventListener('resize', function () { window.ffDrawerAcctSync(); });
  /* Wrapped rather than edited into theme.js, which ships minified: the drawer's own markup calls
     toggleMobileDrawer() through an inline onclick, so it resolves off window at click time and a
     wrapper installed after load is picked up. */
  window.addEventListener('load', function () {
    var orig = window.toggleMobileDrawer;
    if (typeof orig !== 'function' || orig.ffWrapped) return;
    var wrapped = function () {
      var r = orig.apply(this, arguments);
      try { window.ffDrawerAcctSync(); } catch (e) {}
      return r;
    };
    wrapped.ffWrapped = true;
    window.toggleMobileDrawer = wrapped;
  });

  /* ------------------------------------------------------------------ account: boot
     Order matters. The fragment is read and stripped FIRST (synchronously, before anything can log
     or link it), then either the handoff code becomes a session or a stored refresh token is
     exchanged for one. Everything downstream waits on AUTH.ready. */
  function authBoot() {
    var hand = takeHandoff();
    var providers = loadProviders().catch(function () { return null; });
    var step;
    if (hand && hand.error) { AUTH.note = 'Sign-in failed: ' + hand.error; AUTH.open = true; step = Promise.resolve(); }
    else if (hand && hand.code && (function () { try { return window.opener && window.opener !== window && window.opener.location.origin === location.origin && typeof window.opener.ffAuthHandoff === 'function'; } catch (e) { return false; } })()) {
      /* 10-02 playthrough: this is the sign-in pop-up; the page that opened it keeps playing and signs in. */
      window.opener.ffAuthHandoff(hand.code); setTimeout(function () { window.close(); }, 50);
      step = Promise.resolve();
    } else if (hand && hand.code) {
      step = api('/v1/auth/handoff', { body: { code: hand.code, client: 'web', device: deviceName() }, timeout: 15000 })
        .then(afterSignIn)
        .catch(function (e) { AUTH.note = 'That sign-in link has expired — please try again.' + (e && e.status ? ' (' + errText(e) + ')' : ''); AUTH.open = true; });
    } else if (AUTH.refresh) {
      step = refreshSession().then(loadMe).catch(function () { forgetSession(); });
    } else step = Promise.resolve();
    AUTH.ready = Promise.all([providers, step]).then(function () { renderAccount(); renderPro(); }, function () { renderAccount(); renderPro(); });
    return AUTH.ready;
  }

  /* ------------------------------------------------------------------ inline SVG charts (no dependencies) */
  var ORANGE = '#FF7A00', ORANGE2 = '#FFA030', NEG_RED = '#FF4D4D';
  function svgOpen(w, h) { return '<svg class="ffc" viewBox="0 0 ' + w + ' ' + h + '" width="' + w + '" height="' + h + '" style="max-width:100%">'; }
  function cw(el) { return Math.max(320, (el && el.clientWidth) || 1000); }
  function niceMax(v) { if (!(v > 0)) return 1; var p = Math.pow(10, Math.floor(Math.log10(v))); var m = v / p; var n = m <= 1 ? 1 : m <= 2 ? 2 : m <= 5 ? 5 : 10; return n * p; }
  /* nice step for an arbitrary (possibly negative) range, targeting ~4 gridlines */
  function niceStep(range, targetTicks) {
    targetTicks = targetTicks || 4;
    if (!(range > 0)) return 1;
    var raw = range / targetTicks;
    var mag = Math.pow(10, Math.floor(Math.log10(raw)));
    var norm = raw / mag;
    var mult = norm <= 1 ? 1 : norm <= 2 ? 2 : norm <= 5 ? 5 : 10;
    return mult * mag;
  }
  /* domain spanning data min..max, always including 0 (so a zero baseline can be drawn), snapped to nice steps */
  function niceDomain(dataMin, dataMax) {
    var lo = Math.min(0, dataMin), hi = Math.max(0, dataMax);
    if (lo === 0 && hi === 0) hi = 1;
    var step = niceStep(hi - lo, 4);
    lo = Math.floor(lo / step) * step;
    hi = Math.ceil(hi / step) * step;
    if (hi === lo) hi = lo + step;
    return { lo: lo, hi: hi, step: step };
  }
  function axisY(w, h, pad, max, fmt) {
    var s = ''; for (var i = 0; i <= 4; i++) { var y = pad.t + (h - pad.t - pad.b) * (1 - i / 4); s += '<line x1="' + pad.l + '" x2="' + (w - pad.r) + '" y1="' + y + '" y2="' + y + '" class="ffc-grid"/>'; s += '<text x="' + (pad.l - 6) + '" y="' + (y + 4) + '" class="ffc-lab" text-anchor="end">' + esc(fmt(max * i / 4)) + '</text>'; }
    return s;
  }
  /* like axisY but for a full lo..hi domain (used by chartLine, which can go negative) */
  function axisYDomain(w, h, pad, lo, hi, step, fmt) {
    var s = ''; var steps = Math.max(1, Math.round((hi - lo) / step));
    for (var i = 0; i <= steps; i++) {
      var v = lo + i * step;
      var y = pad.t + (h - pad.t - pad.b) * (1 - (v - lo) / (hi - lo));
      s += '<line x1="' + pad.l + '" x2="' + (w - pad.r) + '" y1="' + y.toFixed(1) + '" y2="' + y.toFixed(1) + '" class="ffc-grid"/>';
      s += '<text x="' + (pad.l - 6) + '" y="' + (y + 4).toFixed(1) + '" class="ffc-lab" text-anchor="end">' + esc(fmt(v)) + '</text>';
    }
    return s;
  }
  function axisX(w, h, pad, labels) {
    var s = '', n = labels.length; if (!n) return s; var step = Math.max(1, Math.ceil(n / Math.max(3, Math.floor((w - pad.l - pad.r) / 90))));
    for (var i = 0; i < n; i += step) { var x = pad.l + (w - pad.l - pad.r) * (n === 1 ? .5 : i / (n - 1)); s += '<text x="' + x + '" y="' + (h - 6) + '" class="ffc-lab" text-anchor="middle">' + esc(labels[i]) + '</text>'; }
    return s;
  }
  /* vertical gridlines at the same indices axisX labels, so the crosshair lands on a ruled chart
     rather than on floating ink (the desktop app's `.ffc-grid-v`) */
  function axisXGrid(w, h, pad, labels) {
    var s = '', n = labels.length; if (!n) return s; var step = Math.max(1, Math.ceil(n / Math.max(3, Math.floor((w - pad.l - pad.r) / 90))));
    for (var i = 0; i < n; i += step) { var x = (pad.l + (w - pad.l - pad.r) * (n === 1 ? .5 : i / (n - 1))).toFixed(1); s += '<line x1="' + x + '" x2="' + x + '" y1="' + pad.t + '" y2="' + (h - pad.b) + '" class="ffc-grid ffc-grid-v"/>'; }
    return s;
  }
  function chartLine(el, x, series, opts) {
    opts = opts || {}; var h = opts.h || 260, pad = { l: 56, r: 16, t: 14, b: 26 }, w = cw(el);
    var dataMin = 0, dataMax = 0, any = false;
    series.forEach(function (s) { s.y.forEach(function (v) { v = +v || 0; if (!any) { dataMin = dataMax = v; any = true; } if (v < dataMin) dataMin = v; if (v > dataMax) dataMax = v; }); });
    var dom = niceDomain(dataMin, dataMax), lo = dom.lo, hi = dom.hi, step = dom.step;
    var n = x.length, W = w - pad.l - pad.r, H = h - pad.t - pad.b;
    function yPix(v) { return pad.t + H * (1 - ((v || 0) - lo) / (hi - lo)); }
    var zeroY = yPix(0);
    var _u = ffUid();
    var out = svgOpen(w, h) + '<defs>' +
      '<linearGradient id="' + _u + '-ffg" x1="0" x2="0" y1="0" y2="1"><stop offset="0" stop-color="' + ORANGE + '" stop-opacity=".45"/><stop offset="1" stop-color="' + ORANGE + '" stop-opacity="0"/></linearGradient>' +
      '<linearGradient id="' + _u + '-ffgNeg" x1="0" x2="0" y1="1" y2="0"><stop offset="0" stop-color="' + NEG_RED + '" stop-opacity=".40"/><stop offset="1" stop-color="' + NEG_RED + '" stop-opacity="0"/></linearGradient>' +
      '<clipPath id="' + _u + '-ffClipPos"><rect x="' + pad.l + '" y="' + pad.t + '" width="' + Math.max(0, W) + '" height="' + Math.max(0, zeroY - pad.t) + '"/></clipPath>' +
      '<clipPath id="' + _u + '-ffClipNeg"><rect x="' + pad.l + '" y="' + zeroY + '" width="' + Math.max(0, W) + '" height="' + Math.max(0, (pad.t + H) - zeroY) + '"/></clipPath>' +
      '</defs>';
    var fmtV = opts.fmt || fmtN;
    out += axisYDomain(w, h, pad, lo, hi, step, fmtV) + axisXGrid(w, h, pad, x) + axisX(w, h, pad, x);
    /* the plot frame: the axes themselves, so the plot reads as a chart */
    out += '<line x1="' + pad.l + '" x2="' + pad.l + '" y1="' + pad.t + '" y2="' + (pad.t + H) + '" class="ffc-axis"/>';
    out += '<line x1="' + pad.l + '" x2="' + (w - pad.r) + '" y1="' + (pad.t + H) + '" y2="' + (pad.t + H) + '" class="ffc-axis"/>';
    if (lo < 0 && hi > 0) out += '<line x1="' + pad.l + '" x2="' + (w - pad.r) + '" y1="' + zeroY.toFixed(1) + '" y2="' + zeroY.toFixed(1) + '" class="ffc-zero"/>';
    var geom = [];
    function xAt(i) { return pad.l + W * (n === 1 ? .5 : i / (n - 1)); }
    series.forEach(function (s, si) {
      var pts = s.y.map(function (v, i) { return [xAt(i), yPix(v)]; });
      var d = pts.map(function (p, i) { return (i ? 'L' : 'M') + p[0].toFixed(1) + ' ' + p[1].toFixed(1); }).join(' ');
      var col = si === 0 ? ORANGE : (si === 1 ? ORANGE2 : '#9aa0a6');
      geom.push({ name: s.name, color: col, y: s.y.map(function (v) { return +v || 0; }) });
      if (si === 0) {
        var areaD = d + ' L' + pts[pts.length - 1][0].toFixed(1) + ' ' + zeroY.toFixed(1) + ' L' + pts[0][0].toFixed(1) + ' ' + zeroY.toFixed(1) + ' Z';
        /* area fill split above/below the zero baseline via clip rects, so a negative equity curve reads as red, not orange */
        out += '<path d="' + areaD + '" fill="url(#' + _u + '-ffg)" clip-path="url(#' + _u + '-ffClipPos)"/>';
        out += '<path d="' + areaD + '" fill="url(#' + _u + '-ffgNeg)" clip-path="url(#' + _u + '-ffClipNeg)"/>';
      }
      out += '<path d="' + d + '" fill="none" stroke="' + col + '" stroke-width="2.5" vector-effect="non-scaling-stroke" stroke-linejoin="round"/>';
      /* A lone sample is a zero-length path and therefore invisible: give it a dot. Every OTHER
         point's dot is gone along with its native <title> tooltip — the crosshair below reads the
         value out, and two tooltips fighting over the same pixel is worse than one. */
      if (n === 1 && pts.length) out += '<circle cx="' + pts[0][0].toFixed(1) + '" cy="' + pts[0][1].toFixed(1) + '" r="3.5" fill="' + ((si === 0 && (+s.y[0] || 0) < 0) ? NEG_RED : col) + '"/>';
    });
    /* the crosshair, hidden until the pointer is inside the plot (ported from the desktop app) */
    out += '<g class="ffc-cross" style="display:none">' +
      '<line class="ffc-crossline" x1="0" x2="0" y1="' + pad.t + '" y2="' + (pad.t + H) + '"/>' +
      geom.map(function (g) { return '<circle class="ffc-crossdot" r="4" fill="' + g.color + '" cx="-99" cy="-99"/>'; }).join('') +
      '</g>';
    out += '</svg>';
    if (series.length > 1) out += '<div class="ffc-legend">' + series.map(function (s, i) { return '<span><i style="background:' + (i === 0 ? ORANGE : i === 1 ? ORANGE2 : '#9aa0a6') + '"></i>' + esc(s.name) + '</span>'; }).join('') + '</div>';
    out += '<div class="ffc-tip" hidden></div>';
    el.innerHTML = out;
    /* the geometry is parked on the element so the hover handler never re-derives it */
    el.__ffChart = { w: w, h: h, pad: pad, x: x, n: n, geom: geom, fmt: fmtV, xAt: xAt, yPix: yPix };
    bindCrosshair(el);
  }

  /** ONE mousemove + mouseleave listener per chart. The website's charts are INDEX-spaced (an array
   *  of label strings and a y value per index), not time-spaced like the app's, so the cursor maps
   *  to the nearest data INDEX rather than to an instant: vertical rule at that index's x, a dot per
   *  series at that index, and a readout showing x[i] plus fmt(y[i]) for each series.
   *
   *  The SVG is laid out at its own width but a narrow window scales it, so clientX is mapped
   *  through getBoundingClientRect() into the viewBox's own coordinates — the app's mapping. */
  function bindCrosshair(el) {
    var svg = el.querySelector('svg.ffc'), cross = el.querySelector('.ffc-cross'), tip = el.querySelector('.ffc-tip');
    if (!svg || !cross || !tip) return;
    var line = cross.querySelector('.ffc-crossline'), dots = cross.querySelectorAll('.ffc-crossdot');
    function hide() { cross.style.display = 'none'; tip.hidden = true; }
    function move(clientX) {
      var C = el.__ffChart; if (!C || !C.n) { hide(); return; }
      var r = svg.getBoundingClientRect();
      var vx = (clientX - r.left) / (r.width || 1) * C.w;
      if (vx < C.pad.l - 2 || vx > C.w - C.pad.r + 2) { hide(); return; }
      var W = C.w - C.pad.l - C.pad.r;
      var frac = W > 0 ? (vx - C.pad.l) / W : 0;
      var i = C.n === 1 ? 0 : Math.round(frac * (C.n - 1));
      if (i < 0) i = 0; if (i > C.n - 1) i = C.n - 1;
      var cx = C.xAt(i), html = '';
      C.geom.forEach(function (g, k) {
        var v = g.y[i];
        if (dots[k]) { dots[k].setAttribute('cx', cx.toFixed(1)); dots[k].setAttribute('cy', C.yPix(v).toFixed(1)); }
        html += '<div class="ffc-tip-row"><i style="background:' + g.color + '"></i>' +
          (C.geom.length > 1 ? '<span class="ffc-tip-n">' + esc(g.name) + '</span>' : '') +
          '<b>' + esc(C.fmt(v)) + '</b></div>';
      });
      line.setAttribute('x1', cx.toFixed(1)); line.setAttribute('x2', cx.toFixed(1));
      cross.style.display = '';
      tip.innerHTML = '<div class="ffc-tip-t">' + esc(C.x[i]) + '</div>' + html;
      tip.hidden = false;
      /* keep the readout inside the plot */
      var px = cx / C.w * (r.width || C.w);
      var tw = tip.offsetWidth || 150;
      tip.style.left = Math.max(4, Math.min(px + 14, (el.clientWidth || C.w) - tw - 6)) + 'px';
      tip.style.top = (C.pad.t + 4) + 'px';
    }
    el.addEventListener('mousemove', function (e) { move(e.clientX); });
    el.addEventListener('mouseleave', hide);
    /* The screenshot pass drives the SAME path a real pointer does, so a capture proves the
       crosshair rather than a stub. Reached from the URL as ?mkhover=0.62. */
    el.__ffHoverAt = function (frac) {
      var r = svg.getBoundingClientRect();
      move(r.left + r.width * Math.max(0, Math.min(1, +frac || 0)));
    };
  }
  var _ffUid = 0;
  function ffUid(){ _ffUid++; return 'ff' + _ffUid + '_' + Math.random().toString(36).slice(2,7); }
  function chartBars(el, x, y, opts) {
    opts = opts || {}; var h = opts.h || 260, pad = { l: 56, r: 16, t: 14, b: 26 }, w = cw(el);
    var max = niceMax(Math.max.apply(null, y.concat([0]))); var n = x.length, W = w - pad.l - pad.r, H = h - pad.t - pad.b;
    var bw = Math.max(2, (W / Math.max(n, 1)) * 0.68);
    var _u = ffUid();
    var out = svgOpen(w, h) + '<defs><linearGradient id="' + _u + '-ffb" x1="0" x2="0" y1="0" y2="1"><stop offset="0" stop-color="' + ORANGE2 + '"/><stop offset="1" stop-color="#FF5A00"/></linearGradient></defs>' + axisY(w, h, pad, max, opts.fmt || fmtN) + axisX(w, h, pad, x);
    y.forEach(function (v, i) { var cx = pad.l + W * ((i + .5) / n); var bh = H * ((v || 0) / max); out += '<rect x="' + (cx - bw / 2).toFixed(1) + '" y="' + (pad.t + H - bh).toFixed(1) + '" width="' + bw.toFixed(1) + '" height="' + bh.toFixed(1) + '" rx="2" fill="url(#' + _u + '-ffb)"><title>' + esc(x[i]) + ': ' + esc((opts.fmt || fmtN)(v)) + '</title></rect>'; });
    el.innerHTML = out + '</svg>';
  }
  function chartHeat(el, rows, cols, grid, fmt) {
    var max = 0; grid.forEach(function (r) { r.forEach(function (v) { if (v > max) max = v; }); });
    var html = '<div class="ffh" style="grid-template-columns:70px repeat(' + cols.length + ',minmax(0,1fr))">';
    html += '<div></div>' + cols.map(function (c) { return '<div class="ffh-col">' + esc(c) + '</div>'; }).join('');
    rows.forEach(function (r, ri) { html += '<div class="ffh-row">' + esc(r) + '</div>' + grid[ri].map(function (v, ci) { var a = max ? (v / max) : 0; return '<div class="ffh-cell" style="background:rgba(255,122,0,' + (0.06 + 0.94 * a).toFixed(3) + ')" title="' + esc(r) + ' ' + esc(cols[ci]) + ': ' + esc((fmt || fmtN)(v)) + '"></div>'; }).join(''); });
    el.innerHTML = html + '</div>';
  }
  function tableHtml(columns, rows) {
    return '<div class="fft-wrap"><table class="fft"><thead><tr>' + columns.map(function (c) { return '<th>' + esc(c) + '</th>'; }).join('') + '</tr></thead><tbody>' + rows.map(function (r) { return '<tr>' + r.map(function (c) { return '<td>' + esc(c) + '</td>'; }).join('') + '</tr>'; }).join('') + '</tbody></table></div>';
  }
  function mdLite(md) {
    var lines = String(md || '').split(/\r?\n/), out = '', inList = false, inCode = false;
    function inline(s) { return esc(s).replace(/\*\*(.+?)\*\*/g, '<b>$1</b>').replace(/`([^`]+)`/g, '<code>$1</code>').replace(/\*(.+?)\*/g, '<i>$1</i>'); }
    lines.forEach(function (l) {
      if (/^```/.test(l)) { inCode = !inCode; out += inCode ? '<pre>' : '</pre>'; return; }
      if (inCode) { out += esc(l) + '\n'; return; }
      var m;
      if ((m = /^\s*[-*] (.*)/.exec(l))) { if (!inList) { out += '<ul>'; inList = true; } out += '<li>' + inline(m[1]) + '</li>'; return; }
      if (inList) { out += '</ul>'; inList = false; }
      if ((m = /^(#{1,3}) (.*)/.exec(l))) { out += '<h' + (m[1].length + 2) + '>' + inline(m[2]) + '</h' + (m[1].length + 2) + '>'; return; }
      if (l.trim() === '') return;
      out += '<p>' + inline(l) + '</p>';
    });
    if (inList) out += '</ul>'; if (inCode) out += '</pre>';
    return out;
  }

  /* ------------------------------------------------------------------ brand logos (inline SVG, drawn here) */
  function kalshiLogo(h) {
    h = h || 18; var w = Math.round(h * 4.1);
    return '<svg class="ff-logo ff-logo-kalshi" viewBox="0 0 82 20" width="' + w + '" height="' + h + '" aria-label="Kalshi" role="img"><g fill="#1CDA82"><rect x="1" y="2" width="4.2" height="16" rx="1.2"/><path d="M7.5 10 L15 2 h5 L12.6 10 20 18 h-5 z"/></g><text x="25" y="15.5" font-family="Roboto,Inter,Arial,sans-serif" font-weight="800" font-size="15" fill="#1CDA82" letter-spacing="-.3">Kalshi</text></svg>';
  }
  function kalshiMark(h) { h = h || 16; return '<svg viewBox="0 0 20 20" width="' + h + '" height="' + h + '" aria-hidden="true"><g fill="#1CDA82"><rect x="1" y="2" width="4.2" height="16" rx="1.2"/><path d="M7.5 10 L15 2 h5 L12.6 10 20 18 h-5 z"/></g></svg>'; }
  function polyLogo(h) {
    h = h || 18; var w = Math.round(h * 5.4);
    return '<svg class="ff-logo ff-logo-poly" viewBox="0 0 108 20" width="' + w + '" height="' + h + '" aria-label="Polymarket" role="img"><g fill="none" stroke="#2E5CFF" stroke-width="2.2" stroke-linejoin="round"><path d="M10 1.5 L18 6 V14 L10 18.5 L2 14 V6 Z"/><path d="M2 6 L10 10.5 L18 6 M10 10.5 V18.5"/></g><text x="24" y="15.5" font-family="Roboto,Inter,Arial,sans-serif" font-weight="800" font-size="15" fill="#2E5CFF" letter-spacing="-.3">Polymarket</text></svg>';
  }
  function polyMark(h) { h = h || 16; return '<svg viewBox="0 0 20 20" width="' + h + '" height="' + h + '" aria-hidden="true"><g fill="none" stroke="#2E5CFF" stroke-width="2.2" stroke-linejoin="round"><path d="M10 1.5 L18 6 V14 L10 18.5 L2 14 V6 Z"/><path d="M2 6 L10 10.5 L18 6 M10 10.5 V18.5"/></g></svg>'; }
  window.ffLogos = { kalshiLogo: kalshiLogo, kalshiMark: kalshiMark, polyLogo: polyLogo, polyMark: polyMark };

  /* ------------------------------------------------------------------ tabs + venue */
  /* THE COLOUR IS ON THE TEXT STRIP, NOT ON THE TRACK.
     `bg-orange-100 dark:bg-orange-900/50` filled the whole row band with orange, so the
     selected section read as an orange TRACK rather than as orange text. The desktop app has
     always done it the other way — a neutral grey band (`--ctl`) carrying orange text and an
     orange left bar — and that is what the row does here now. `ff-nav-on` is the neutral band;
     the orange is the text colour and the left border, and nothing else. */
  var ACTIVE = 'ff-nav-on text-orange-800 dark:text-orange-300 font-bold border-orange-500'.split(' ');
  var INACTIVE = 'hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-400 border-transparent'.split(' ');
  /* LEGACY_FILL is the row-tint this file used to apply, and which layout/theme.liquid still bakes
     onto #nav-episodes as its initial selected state.
     It has to be removed explicitly. `setNavActive(el, false)` only strips the classes currently in
     ACTIVE, so the moment ACTIVE stopped listing these, a row that was born with them kept its
     orange fill forever — All Episodes sat there tinted while Markets was the selected section.
     Removing them on BOTH paths makes every call self-healing, whatever state the markup shipped. */
  var LEGACY_FILL = ['bg-orange-100', 'dark:bg-orange-900/50', 'bg-orange-900/50'];
  function setNavActive(el, on) {
    if (!el) return;
    el.classList.remove.apply(el.classList, LEGACY_FILL);
    if (on) { el.classList.remove.apply(el.classList, INACTIVE); el.classList.add.apply(el.classList, ACTIVE); }
    else { el.classList.remove.apply(el.classList, ACTIVE); el.classList.add.apply(el.classList, INACTIVE); }
  }

  function restartTypewriter() {
    try {
      clearTimeout(typewriterTimeout); isDeleting = false; charIndex = 0;
      window.ffPhrases = FF.tab === 'predictions' ? AI_PHRASES : null;
      window.currentTargetPhrase = (window.ffPhrases || funnyPhrases)[0];
      var mt = $('mobileTypewriterText');
      if (typewriterText) typewriterText.innerText = 'Search for ';
      if (mt) mt.innerText = 'Search for ';
      window.ffSearchPlaceholder = FF.tab === 'predictions' ? 'Ask about Kalshi or Polymarket data...' : 'Search for transcripts or episodes...';
      var si = $('searchInput'); if (si && si.placeholder) si.placeholder = window.ffSearchPlaceholder;
      if (si && si.value.length === 0 && placeholderContainer && placeholderContainer.style.display !== 'none') typeWriterEffect();
    } catch (e) { console.warn('typewriter restart', e); }
  }

  /* ------------------------------------------------------------------ Markets disclosure group
   * Ported from the desktop app's rail (main.ts, setMarketsOpen/marketsItem.onclick): the group is
   * CLOSED on a fresh load, clicking Markets opens it and selects Kalshi, clicking it again closes
   * it and leaves Markets itself the selected row. The state is remembered for this tab only
   * (sessionStorage), under the app's own pref name, so a genuinely fresh load starts closed. */
  var MKT_KEY = 'marketsOpen2';
  function marketsOpen() { try { return sessionStorage.getItem(MKT_KEY) === '1'; } catch (e) { return false; } }
  function setMarketsOpen(open) {
    try { sessionStorage.setItem(MKT_KEY, open ? '1' : '0'); } catch (e) {}
    var row = $('nav-predictions'), grp = $('nav-markets-group');
    if (row) { row.classList.toggle('ff-open', open); row.setAttribute('aria-expanded', open ? 'true' : 'false'); }
    if (grp) { grp.classList.toggle('open', open); grp.setAttribute('aria-hidden', open ? 'false' : 'true'); }
    syncNav();
  }
  /* The sidebar's selected row.
   *
   * THE RULE: "Market Data" — the Markets row — is the SELECTED SECTION whenever the markets view is
   * on screen, so it wears the site's orange ACTIVE classes at all times, open or closed. It never
   * goes grey just because the disclosure group is expanded, and it never takes a venue's colour.
   *
   * A venue child carries its own brand colour and ONLY its own: Kalshi selected is green,
   * Polymarket selected is blue. The parent does not inherit the child — `.ff-sub-kalshi.ff-sub-on`
   * / `.ff-sub-poly.ff-sub-on` are scoped to the child rows, and `--venue`/`--venue-soft` are set on
   * `#ffPredictions` (the panel), never on the sidebar, so neither can reach this row. */
  function syncNav() {
    var open = marketsOpen();
    setNavActive($('nav-predictions'), FF.tab === 'predictions');
    setNavActive($('nav-episodes'), FF.tab === 'episodes');
    setNavActive($('nav-discs'), FF.tab === 'discs');
    setNavActive($('nav-app'), FF.tab === 'app');
    setNavActive($('nav-email'), FF.tab === 'email');
    var emailNav=$('nav-email'); if(emailNav){ emailNav.removeAttribute('aria-haspopup'); emailNav.removeAttribute('aria-expanded'); }
    var pi = $('predictionsNavIcon'); if (pi) pi.classList.toggle('text-orange-500', FF.tab === 'predictions');
    ['nav-kalshi', 'nav-polymarket'].forEach(function (id) {
      var el = $(id); if (el) el.classList.toggle('ff-sub-on', FF.tab === 'predictions' && open && id === 'nav-' + FF.venue);
    });
  }
  window.ffToggleMarkets = function () {
    var open = !marketsOpen();
    setMarketsOpen(open);
    /* Opening picks a venue rather than leaving a chooser nobody wants: Kalshi is the default.
       Closing leaves the view where it is — it must not deselect Markets or navigate away. */
    if (open) { if (!(FF.tab === 'predictions' && FF.venue === 'kalshi')) window.ffSelectVenue('kalshi'); }
    else if (FF.tab !== 'predictions') window.ffShowTab('predictions');
  };

  window.ffShowTab = function (tab, opts) {
    opts = opts || {};
    if (tab === 'app' && !window.ffEditorAvailable()) tab = 'episodes';
    /* owner 2026-09-28: not the owner (or not known yet) -> predictions does not exist. A request made
       before /v1/me has answered for a stored session is remembered and honoured if it says owner. */
    if (tab === 'predictions' && !FF.owner) {
      var st = null; try { st = localStorage.getItem('tff_refresh'); } catch (e) {}
      ownerPending = st ? { force: true, silent: !!opts.silent } : null;
      tab = 'episodes';
    }
    if (tab === 'predictions' && !window.ffAtHome()) { window.location.href = '/?tab=predictions&venue=' + FF.venue; return; }
    /* 'app' is the THIRD view — the centre tab of the phone bar, the App Store panel. It is a
       panel in this page like the other two, so coming back to the episode list is one tap. */
    if (tab === 'app' && !window.ffAtHome()) { window.location.href = '/?tab=app'; return; }
    /* 10-02: 'discs' is the DVD/Blu-rays store as a tab of this page (#ffDiscs, tff-discs.js), and the
       tab a visitor lands on (boot). From another page it is the home page's tab. */
    if (tab === 'discs' && !window.ffAtHome()) { window.location.href = '/?tab=discs'; return; }
    var changed = FF.tab !== tab; FF.tab = tab;
    if (tab === 'email' && !window.ffAtHome()) { window.location.href = '/?tab=email'; return; }
    var pm = $('ffMail'); if (pm) pm.hidden = tab !== 'email';
    var ne = $('nav-email'); if (ne) { ne.classList.toggle('text-orange-500', tab === 'email'); if(tab === 'email')ne.setAttribute('aria-current','page');else ne.removeAttribute('aria-current'); }
    var pc = $('pageContent'), pp = $('ffPredictions'), pa = $('ffAppPromo'), pd = $('ffDiscs'), pg = $('ffPage');
    if (pg) pg.hidden = (tab !== 'page');   /* 10-02 playthrough: a same-site page shown in this one (tff-shell.js) */
    if (pc) pc.hidden = (tab !== 'episodes');
    if (pp) pp.hidden = (tab !== 'predictions');
    if (pa) pa.hidden = (tab !== 'app');
    if (pd) pd.hidden = (tab !== 'discs');
    document.documentElement.classList.toggle('ff-tab-discs', tab === 'discs');
    syncNav();
    /* The phone bar is the site's own two-item bar again — the inbox in its orange tile and the
       chart glyph — so these are back to the per-item active classes the theme's mobile block
       styles (.bottom-nav-item.active-inbox / .active-predictions). The three-item labelled
       version, and the single `ff-tab-on` class it shared, belonged to the iOS-app copy that was
       reverted on 2026-09-26; the Editor tab exists on the APP's bar only, never here. */
    var mb = $('mobilePredictionsBtn'), mi = $('mobileInboxBtn'), ma = $('mobileAppBtn');
    if (mb) mb.classList.toggle('active-predictions', tab === 'predictions');
    if (mi) mi.classList.toggle('active-inbox', tab === 'episodes');
    if (ma) ma.classList.toggle('active-app', tab === 'app');
    var md = $('mobileDiscsBtn'); if (md) md.classList.toggle('active-discs', tab === 'discs');
    [mb, mi, ma, md].forEach(function (b) { if (!b) return; var on = b.classList.contains('active-predictions') || b.classList.contains('active-inbox') || b.classList.contains('active-app') || b.classList.contains('active-discs'); if (on) b.setAttribute('aria-current', 'page'); else b.removeAttribute('aria-current'); });
    /* The landing tab (discs) has the bare URL; the others say which tab they are, so a reload or a
       shared link comes back to the same tab. Only on the home page — elsewhere boot shows the page. */
    if (!opts.silent && tab !== 'page' && window.ffAtHome()) { try { var u = new URL(window.location.href); if (u.searchParams.has('view')) u = new URL('/', u.origin);
      /* 10-20 (T011/T095): the clean addresses */
      var sp = new URLSearchParams(u.search), pth = '/', viaTab = u.searchParams.get('tab'); sp.delete('_su_rec'); sp.delete('_su_rec_id');
      if (tab === 'email' || tab === 'discs') { sp.delete('tab'); sp.delete('venue'); pth = tab === 'email' ? '/playlists' : '/market'; }
      else if (tab === 'predictions') { sp.set('tab', 'predictions'); sp.set('venue', FF.venue); }
      else if (tab === 'app' || tab === 'episodes') { sp.set('tab', tab); sp.delete('venue'); }
      var want = pth + (sp.toString() ? '?' + sp.toString() : '') + u.hash;
      if (want !== u.pathname + (u.search || '') + u.hash) {
        /* the shell has just pushed /?tab=<this tab> for a link click: replace that entry, otherwise a change of tab adds one */
        var shellPushed = viaTab === tab || (viaTab === 'dvds' || viaTab === 'store') && tab === 'discs';
        if (changed && !shellPushed && !opts.replace) history.pushState({ ffTab: tab }, '', want); else history.replaceState(history.state, '', want);
      } } catch (e) {} }
    if (changed || opts.force) restartTypewriter();
    if (tab === 'predictions') { renderVenue(); loadAll(); var mc = $('mainContainer'); if (mc) mc.scrollTop = 0; }
    if (tab === 'app') { var mc2 = $('mainContainer'); if (mc2) mc2.scrollTop = 0; if (typeof window.ffAppRender === 'function') window.ffAppRender(); }
    if (tab === 'email' && typeof window.ffMailShow === 'function') { var mm = $('mainContainer'); if(mm) mm.scrollTop=0;window.ffMailShow(); }
    if (tab === 'discs') { var mc3 = $('mainContainer'); if (mc3) mc3.scrollTop = 0; if (typeof window.ffDiscsShow === 'function') window.ffDiscsShow(); }
    if (window.innerWidth < 768) { var d = $('mobileDrawer'); if (d && d.classList.contains('open') && typeof toggleMobileDrawer === 'function') toggleMobileDrawer(); }
  };
  window.ffSelectVenue = function (v) {
    if (!VENUES[v]) return;
    var changed = FF.venue !== v; FF.venue = v; FF.category = ''; FF.series = '';
    window.ffShowTab('predictions', { force: changed });
  };
  window.ffGoEpisodes = function () { if (!window.ffAtHome()) { window.location.href = '/?tab=episodes'; return; } window.ffShowTab('episodes'); if (typeof goHome === 'function') goHome(); };

  /* wrap theme.js globals so the tab logic sees them */
  var _performSearch = window.performSearch;
  window.performSearch = function () { if (FF.tab === 'predictions') { ask(); return; } if (FF.tab === 'discs' || FF.tab === 'app' || FF.tab === 'page') window.ffShowTab('episodes'); return _performSearch && _performSearch.apply(this, arguments); };
  var _goHome = window.goHome;
  window.goHome = function () { if (!window.ffAtHome()) { window.location.href = '/?tab=episodes'; return; } if (FF.tab !== 'episodes') window.ffShowTab('episodes'); return _goHome && _goHome.apply(this, arguments); };
  var _goToEpisodes = window.goToEpisodes;
  window.goToEpisodes = function () { if (!window.ffAtHome()) { window.location.href = '/?tab=episodes'; return; } if (FF.tab !== 'episodes') window.ffShowTab('episodes'); return _goToEpisodes && _goToEpisodes.apply(this, arguments); };
  var _hsf = window.handleSearchFocus;
  window.handleSearchFocus = function () { var r = _hsf && _hsf.apply(this, arguments); var si = $('searchInput'); if (si && window.ffSearchPlaceholder) si.placeholder = window.ffSearchPlaceholder; renderHistory(); return r; };
  var _hsb = window.handleSearchBlur;
  window.handleSearchBlur = function () { var r = _hsb && _hsb.apply(this, arguments); var si = $('searchInput'); if (si && window.ffSearchPlaceholder && si.value.length === 0) si.placeholder = window.ffSearchPlaceholder; setTimeout(hideHistory, 150); return r; };
  var _usu = window.updateSearchUI;
  window.updateSearchUI = function () { var r = _usu && _usu.apply(this, arguments); var si = $('searchInput'); if (si && document.activeElement === si) renderHistory(); return r; };

  /* ------------------------------------------------------------------ search history (localStorage only — never sent anywhere) */
  var HIST_KEY = 'tff_ask_history', HIST_MAX = 50;
  function loadHistory() { try { var h = JSON.parse(localStorage.getItem(HIST_KEY) || '[]'); return Array.isArray(h) ? h.filter(function (x) { return typeof x === 'string'; }) : []; } catch (e) { return []; } }
  function saveHistory(q) { try { var h = loadHistory().filter(function (x) { return x !== q; }); h.unshift(q); localStorage.setItem(HIST_KEY, JSON.stringify(h.slice(0, HIST_MAX))); } catch (e) {} }
  function clearHistory() { try { localStorage.removeItem(HIST_KEY); } catch (e) {} renderHistory(); }
  window.ffClearHistory = clearHistory;
  function historyBox() {
    var box = $('ffAskHistory');
    if (!box) { var bar = $('searchBarContainer'); if (!bar) return null; box = document.createElement('div'); box.id = 'ffAskHistory'; box.className = 'ff-hist'; box.hidden = true; bar.appendChild(box); }
    return box;
  }
  function hideHistory() { var box = $('ffAskHistory'); if (box) box.hidden = true; }
  function renderHistory() {
    var box = historyBox(); if (!box) return;
    var si = $('searchInput'); var typed = (si && si.value.trim().toLowerCase()) || '';
    var items = loadHistory().filter(function (q) { return !typed || q.toLowerCase().indexOf(typed) >= 0; }).slice(0, 8);
    if (FF.tab !== 'predictions' || !items.length) { box.hidden = true; box.innerHTML = ''; return; }
    box.innerHTML = '<div class="ff-hist-head"><span><i class="fas fa-history"></i> Recent searches — stored in this browser only</span><a href="#" class="ff-hist-clear" onmousedown="event.preventDefault();window.ffClearHistory();">clear history</a></div>' +
      items.map(function (q) { return '<div class="ff-hist-item" data-q="' + esc(q) + '"><i class="fas fa-magic"></i><span>' + esc(q) + '</span></div>'; }).join('');
    box.querySelectorAll('.ff-hist-item').forEach(function (el) {
      el.addEventListener('mousedown', function (ev) { ev.preventDefault(); var q = el.getAttribute('data-q'); if (si) si.value = q; box.hidden = true; try { updateSearchUI(); } catch (e) {} ask(); });
    });
    box.hidden = false;
  }

  /* ------------------------------------------------------------------ range + interval chip rows
   * The theme uses Font Awesome rather than the app's inline icon set, so the padlock is
   * <i class="fas fa-lock"> and the Custom chip's glyph <i class="fas fa-calendar"> — the theme's
   * own idiom. Everything else is the app's markup and classes. */
  function lockIcon() { return ' <i class="fas fa-lock ff-chip-lockico" aria-hidden="true"></i>'; }
  function rangeChips() {
    return RANGES.map(function (r) {
      return '<button type="button" data-v="' + r.v + '" class="ff-chip' + (r.pro ? ' ff-chip-locked' : '') + '"' +
        (r.pro ? ' title="' + esc(RANGE_LOCK_COPY) + '" data-tip="' + esc(RANGE_LOCK_COPY) + '"' : '') + '>' +
        (r.custom ? '<i class="fas fa-calendar" aria-hidden="true"></i> ' : '') + esc(r.label) + (r.pro ? lockIcon() : '') + '</button>';
    }).join('');
  }
  function intervalChips() {
    return intervalOrder().map(function (g) {
      var pro = g.pro || isProBucket(g.v);
      return '<button type="button" data-v="' + g.v + '" class="ff-chip' + (pro ? ' ff-chip-locked' : '') + '"' +
        (pro ? ' title="' + esc(LOCK_COPY) + '"' : '') + '>' + esc(g.short || g.v) + (pro ? lockIcon() : '') + '</button>';
    }).join('');
  }

  /* ------------------------------------------------------------------ predictions panel */
  function renderVenue() {
    var root = $('ffPredictions'); if (!root) return;
    var V = VENUES[FF.venue];
    root.style.setProperty('--venue', V.color); root.style.setProperty('--venue-soft', V.soft);
    if (!root.dataset.built) {
      root.dataset.built = '1';
      root.innerHTML =
        '<div id="ffAskPanel" class="ff-card ff-ask" hidden></div>' +
        '<div class="ff-vhead"><div class="ff-vtitle"><span id="ffVenueName"></span><span id="ffVenueLogo"></span></div>' +
          '<div class="ff-vhead-right"><div class="ff-vmeta"><div class="ff-depth" id="ffVenueDepth">\u2026</div>' +
            '<div class="ff-vsub" id="ffVenueSub"></div></div>' +
            '<div id="ffStatusPill" class="ff-pill">checking…</div><button id="ffAcctBtn" class="ff-acct-btn" hidden></button></div></div>' +
        '<div class="ff-card ff-acct" id="ffAcctPanel" hidden></div>' +
        /* Labelled control rows, as the desktop app has them: every group says what it is above
           itself instead of relying on a tooltip. The website keeps its simpler <input list>
           series picker rather than the app's full combobox. */
        '<div class="ff-controls" id="ffChips">' +
          '<div class="ff-ctl"><label class="ff-ctl-l" for="ffCat">Category</label>' +
            '<select id="ffCat" class="ff-chip ff-select"><option value="">All categories</option></select></div>' +
          '<div class="ff-ctl ff-ctl-wide"><label class="ff-ctl-l" for="ffSeries">Series</label>' +
            '<span class="ff-chip ff-chip-input"><i class="fas fa-search"></i><input id="ffSeries" list="ffSeriesList" placeholder="Series — name or ticker…" autocomplete="off" spellcheck="false"><datalist id="ffSeriesList"></datalist></span></div>' +
          '<div class="ff-ctl"><span class="ff-ctl-l">Range</span>' +
            '<span class="ff-chipgroup" data-key="range" id="ffRange">' + rangeChips() + '</span></div>' +
          '<div class="ff-ctl"><span class="ff-ctl-l" id="ffIntervalL">Interval</span>' +
            '<span class="ff-chipgroup" data-key="bucket" id="ffInterval">' + intervalChips() + '</span></div>' +
          '<div class="ff-ctl"><span class="ff-ctl-l">Side</span>' +
            '<span class="ff-chipgroup" data-key="side"><button type="button" data-v="both" class="ff-chip">BOTH</button><button type="button" data-v="yes" class="ff-chip">YES</button><button type="button" data-v="no" class="ff-chip">NO</button></span></div>' +
          '<div class="ff-ctl"><label class="ff-ctl-l" for="ffMetric">Metric</label>' +
            '<select id="ffMetric" class="ff-chip ff-select"><option value="trades">Trades</option><option value="contracts">Contracts</option><option value="notional">Notional</option><option value="price">Price</option></select></div>' +
          '<div class="ff-ctl"><label class="ff-ctl-l" for="ffBand">Price band</label>' +
            '<select id="ffBand" class="ff-chip ff-select"><option value="all">All prices</option><option value="1-5">1–5¢</option><option value="5-20">5–20¢</option><option value="20-50">20–50¢</option><option value="50-80">50–80¢</option><option value="80-99">80–99¢</option></select></div>' +
        '</div>' +
        '<div class="ff-custom" id="ffCustom" hidden>' +
          '<label>From<input type="date" id="ffCustomFrom"></label>' +
          '<label>To<input type="date" id="ffCustomTo"></label>' +
          '<button type="button" class="ff-btn" id="ffCustomApply">Apply range</button>' +
          '<span class="ff-muted" id="ffCustomNote"></span>' +
        '</div>' +
        '<div class="ff-modes" id="ffModes"><button data-v="line" class="ff-mode"><i class="fas fa-chart-line"></i>Line</button><button data-v="bars" class="ff-mode"><i class="fas fa-signal"></i>Bars</button><button data-v="table" class="ff-mode"><i class="fas fa-table"></i>Table</button><button data-v="heatmap" class="ff-mode"><i class="fas fa-th"></i>Heatmap</button></div>' +
        '<div class="ff-stats" id="ffStats"></div>' +
        '<div class="ff-card ff-chartcard"><div class="ff-card-head"><span id="ffChartTitle">Activity</span><span id="ffChartSub" class="ff-muted"></span></div>' +
          '<div id="ffCoverage" class="ff-coverage" hidden></div>' +
          '<div id="ffChartBody" class="ff-chartbody"></div></div>' +
        '<div class="ff-grid2">' +
          '<div class="ff-card" id="ffBacktest"><div class="ff-card-head"><span><i class="fas fa-flask"></i> Backtest</span><span class="ff-muted">POST /v1/backtest</span></div>' +
            '<form id="ffBtForm" class="ff-form" onsubmit="return false;">' +
              '<label>Category / series<input id="btScope" placeholder="e.g. baseball or KXMLBGAME"></label>' +
              '<label>Side<select id="btSide"><option value="yes">YES</option><option value="no">NO</option></select></label>' +
              '<label>Entry (¢)<input id="btEntry" type="number" min="1" max="99" value="20"></label>' +
              '<label>Exit<select id="btExit"><option value="settle">Hold to settlement</option><option value="50">Sell at 50¢</option><option value="80">Sell at 80¢</option><option value="95">Sell at 95¢</option><option value="99">Sell at 99¢</option><option value="custom">Sell at custom ¢</option></select></label>' +
              '<label id="btExitCWrap" hidden>Sell at (¢)<input id="btExitC" type="number" min="1" max="99" step="1" value="60" placeholder="1–99"></label>' +
              '<label>From<input id="btFrom" type="date"></label><label>To<input id="btTo" type="date"></label>' +
              '<button id="btRun" class="ff-btn">Run backtest</button>' +
            '</form><div id="ffBtOut" class="ff-btout"></div></div>' +
          '<div class="ff-card ff-pro" id="ffPro"></div>' +
        '</div>';
      wireChips();
      var t = new Date(), f = new Date(t.getTime() - 30 * 86400000);
      $('btTo').value = fmtDayISO(t); $('btFrom').value = fmtDayISO(f);
      $('ffCustomTo').value = fmtDayISO(t); $('ffCustomFrom').value = fmtDayISO(new Date(t.getTime() - 7 * 86400000));
      $('btRun').addEventListener('click', runBacktest);
      $('ffAcctBtn').addEventListener('click', function () { if (AUTH.open) { AUTH.open = false; renderAccount(); } else openAccount(); });
    }
    $('ffVenueName').textContent = ''; $('ffVenueLogo').innerHTML = V.logo(30); $('ffVenueLogo').setAttribute('aria-label', V.name);
    // The depth is PER VENUE and is refilled on the switch from the health payload already in hand,
    // so it never shows the other venue's number while the next poll is in flight.
    renderVenueDepth();
    syncChips(); renderPro(); renderAccount();
  }
  function wireChips() {
    wireRangeButtons();
    wireIntervalButtons();
    document.querySelectorAll('#ffChips .ff-chipgroup[data-key="side"]').forEach(function (g) {
      g.querySelectorAll('button').forEach(function (b) { b.addEventListener('click', function () { FF.side = b.dataset.v; syncChips(); loadAll(); }); });
    });
    $('ffModes').querySelectorAll('button').forEach(function (b) { b.addEventListener('click', function () { FF.mode = b.dataset.v; syncChips(); renderChart(); }); });
    $('ffCat').addEventListener('change', function () { FF.category = this.value; FF.series = ''; $('ffSeries').value = ''; FF.bucket = autoInterval(); syncChips(); loadAll(); });
    $('ffBand').addEventListener('change', function () { FF.band = this.value; renderChart(); });
    $('ffMetric').addEventListener('change', function () { FF.metric = this.value; loadAll(); });
    $('ffCustomApply').addEventListener('click', function () {
      FF.customFrom = $('ffCustomFrom').value; FF.customTo = $('ffCustomTo').value;
      FF.range = 'custom'; applyTierToSelection(); syncChips(); loadAll();
    });
    /* Exit "Sell at custom ¢" reveals the cent box; every other exit hides it again. */
    $('btExit').addEventListener('change', function () { $('btExitCWrap').hidden = this.value !== 'custom'; if (this.value === 'custom') $('btExitC').focus(); });
    var st = null;
    function takeSeries(v) { FF.series = v; FF.bucket = autoInterval(); syncChips(); loadAll(); }
    $('ffSeries').addEventListener('input', function () { var q = this.value.trim(); clearTimeout(st); st = setTimeout(function () { suggestSeries(q); }, 250); });
    $('ffSeries').addEventListener('change', function () { takeSeries(this.value.trim()); });
    $('ffSeries').addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); takeSeries(this.value.trim()); } });
  }
  function wireRangeButtons() { $('ffRange').querySelectorAll('button').forEach(function (b) { b.addEventListener('click', function () { pickRange(b.dataset.v); }); }); }
  function wireIntervalButtons() { $('ffInterval').querySelectorAll('button').forEach(function (b) { b.addEventListener('click', function () { pickInterval(b.dataset.v); }); }); }

  function pickRange(v) {
    var r = rangeDef(v);
    if (r.pro && !proActive()) { showUpsell('3 months of history', RANGE_LOCK_COPY); return; }
    FF.range = v;
    $('ffCustom').hidden = v !== 'custom';
    FF.bucket = autoInterval();
    syncChips(); loadAll();
  }
  function pickInterval(v) {
    var g = interval(v);
    /* A locked chip SHOWS THE UPSELL. It never silently does nothing — a dead control teaches the
       visitor that the product is broken rather than that the bar is for sale. */
    if ((g.pro || isProBucket(v)) && !proActive()) { showUpsell(proWhat(v), LOCK_COPY); return; }
    var why = intervalBlocked(g);
    if (why) { syncChips(); flash(why); return; }
    FF.bucket = v; syncChips(); loadAll();
  }
  /** What the padlock on an interval is selling, in the words the upsell wants. */
  function proWhat(v) {
    if (v === 'tick') return 'tick-by-tick history';
    if (v === '1m') return 'minute-by-minute history';
    if (v === '3M') return '3 month intervals';
    return interval(v).label;
  }
  /** Why an interval cannot serve the current selection — the same rules the API enforces, said in
   *  the UI so a dimmed chip can explain itself instead of just being dead. */
  function intervalBlocked(g) {
    var win = windowOf();
    if (win.days > g.maxDays) return g.label + ' is served over at most ' + g.maxDays + ' days';
    if (g.sec > 86400 && win.days < Math.round(g.sec / 86400)) return g.label + ' need a window of at least ' + Math.round(g.sec / 86400) + ' days — pick 3M or Custom';
    if (!proActive() && win.days > 31) return 'the free tier serves a rolling 31-day window';
    if (g.sec < 3600 && g.sec > 0 && !FF.series) return 'pick a series first — intra-hour history is per series, not per venue';
    if (g.sec === 0 && !FF.series) return 'pick a series first';
    return '';
  }
  /** The finest interval ALLOWED TO THIS CALLER right now: density by default, not a 30-point month.
   *  A free account on a one-day window lands on 5m, never on a minute bar it is not entitled to. */
  function autoInterval() {
    var win = windowOf();
    var want = FF.series
      ? (win.days <= 1 ? ['1m', '5m', '15m', '1h'] : win.days <= 7 ? ['5m', '15m', '1h'] : win.days <= 31 ? ['15m', '1h', '1d'] : ['1d'])
      : (win.days <= 7 ? ['1h', '1d'] : ['1d']);
    for (var i = 0; i < want.length; i++) {
      var g = interval(want[i]);
      var locked = (g.pro || isProBucket(want[i])) && !proActive();
      if (!locked && !intervalBlocked(g)) return want[i];
    }
    return '1d';
  }
  /** Keep the selection legal after the tier, the range or the scope changes. */
  function applyTierToSelection() {
    if (rangeDef(FF.range).pro && !proActive()) FF.range = '30d';
    var g = interval(FF.bucket);
    if (((g.pro || isProBucket(FF.bucket)) && !proActive()) || intervalBlocked(g)) FF.bucket = autoInterval();
    return true;
  }
  /** A one-line note above the chart, in the app's `.ff-coverage` box. */
  function flash(msg) {
    var n = $('ffCoverage'); if (!n) return;
    n.hidden = false; n.className = 'ff-coverage ff-coverage-warn';
    n.innerHTML = '<i class="fas fa-info-circle"></i> ' + esc(msg);
  }
  /* ---------------------------------------------------------------- the coverage line
     What the chart is actually built from, said plainly under it. The important distinction it
     carries is between a gap and a LIMIT: at 1 day this dataset goes back to May, at 1 hour it goes
     back as far as the hourly rollup plus the tape this box holds. "21 days not held" reads as
     something broken, so when the server sends a note explaining the floor, the note is what the
     visitor sees. Days are never filled in to make the line look complete. */
  function renderCoverage(t) {
    var n = $('ffCoverage'); if (!n) return;
    var c = t && t.coverage;
    if (!c) { n.hidden = true; n.innerHTML = ''; return; }
    var got = c.days_with_data || [], missing = c.missing_days || [], pend = c.pending_days || [];
    var unk = c.side_unknown_days || [];
    // ONE PLAIN SENTENCE, composed by the server (coverage.sentence) so the website, the three desktop
    // apps, iOS and tvOS all say the same thing. The line used to be a dot-separated list ending in
    // the raw machine token ("source: aggregates+hourly-rollup+history") — that token is what read as
    // random noise — and it hid itself entirely on a clean window, so the site said nothing at all
    // about how much data it was drawing from. It is now always shown.
    var line = c.sentence;
    if (!line) {
      line = got.length
        ? 'Drawn from ' + got.length + ' day' + (got.length === 1 ? '' : 's') + ' of data (' + got[0] + ' \u2192 ' + got[got.length - 1] + ').'
        : 'No day of this window is held, so there is nothing to draw.';
      if (missing.length) line += ' ' + missing.length + ' other day' + (missing.length === 1 ? ' has' : 's have') + ' no data held.';
    }
    n.hidden = false;
    n.className = 'ff-coverage' + ((pend.length || missing.length || unk.length) ? ' ff-coverage-warn' : '');
    n.innerHTML = '<i class="fas fa-info-circle"></i> ' + esc(line) +
      (c.note ? '<div class="ff-coverage-note">' + esc(c.note) + '</div>' : '');
  }

  /** A locked control was clicked: say what it buys and put the Pro card in front of the visitor. */
  function showUpsell(what, why) {
    flash((what ? what[0].toUpperCase() + what.slice(1) : 'This') + ' is part of Pro — ' + (why || LOCK_COPY) + '.');
    var pro = $('ffPro');
    if (pro) {
      pro.classList.add('ff-pro-flash');
      setTimeout(function () { pro.classList.remove('ff-pro-flash'); }, 1600);
      try { pro.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) { pro.scrollIntoView(); }
    }
  }

  function syncChips() {
    $('ffRange').querySelectorAll('button').forEach(function (b) {
      var r = rangeDef(b.dataset.v), locked = !!r.pro && !proActive();
      b.classList.toggle('on', FF.range === b.dataset.v);
      b.classList.toggle('ff-chip-locked', locked);
    });
    $('ffInterval').querySelectorAll('button').forEach(function (b) {
      var g = interval(b.dataset.v);
      /* The padlock is the TIER's, and it stays on a subscriber-only bucket whatever the window
         happens to be — a free account never sees 1m or Tick open, on any series or any venue. */
      var locked = (g.pro || isProBucket(b.dataset.v)) && !proActive();
      var why = locked ? LOCK_COPY : intervalBlocked(g);
      b.classList.toggle('on', FF.bucket === b.dataset.v);
      b.classList.toggle('ff-chip-off', !!why && !locked);
      b.classList.toggle('ff-chip-locked', locked);
      b.setAttribute('title', why || g.label);
    });
    document.querySelectorAll('#ffChips .ff-chipgroup[data-key="side"] button').forEach(function (b) { b.classList.toggle('on', FF.side === b.dataset.v); });
    $('ffModes').querySelectorAll('button').forEach(function (b) { b.classList.toggle('on', FF.mode === b.dataset.v); });
    $('ffBand').value = FF.band; $('ffMetric').value = FF.metric;
    $('ffCustom').hidden = FF.range !== 'custom';
    if (FF.customFrom) $('ffCustomFrom').value = FF.customFrom;
    if (FF.customTo) $('ffCustomTo').value = FF.customTo;
    var w = windowOf();
    $('ffCustomNote').textContent = FF.range === 'custom'
      ? w.days + (w.days === 1 ? ' day' : ' days') + (proActive() ? '' : ' · the free tier allows up to 31')
      : '';
    /* The Interval label carries the free floor while the account is free, so the padlocks on 1m
       and Tick have a sentence beside them instead of only a price. */
    var il = $('ffIntervalL');
    if (il) { il.setAttribute('title', proActive() ? 'Every interval, down to each tick' : FREE_FLOOR_COPY); il.classList.toggle('ff-ctl-l-free', !proActive()); }
    var bx = $('btExit'), bw = $('btExitCWrap');
    if (bx && bw) bw.hidden = bx.value !== 'custom';
  }
  function suggestSeries(q) {
    authFetch('/v1/' + FF.venue + '/series?' + qs({ q: q, category: FF.category, limit: 12 })).then(function (list) {
      $('ffSeriesList').innerHTML = (list || []).map(function (s) { return '<option value="' + esc(s.series) + '">' + esc(s.title || '') + '</option>'; }).join('');
    }).catch(function () {});
  }

  /* ------------------------------------------------------------------ venue depth
   * "N days of data" for the venue being shown, from /v1/health's per-venue `coverage` block. The
   * server measures it across the trade lake, the hourly rollup AND the full daily history, so Kalshi
   * reads 138 days and Polymarket 27 — different numbers, both correct. Never a constant, and never
   * the old "free 30-day tier" phrasing, which described the FREE WINDOW and was read as the depth of
   * the dataset. (The pill still says what the tier serves; that is a different fact.) */
  function venueCoverage() {
    var h = FF.health;
    return (h && h.venues && h.venues[FF.venue] && h.venues[FF.venue].coverage) || null;
  }
  function renderVenueDepth() {
    var d = $('ffVenueDepth'), sub = $('ffVenueSub');
    var c = venueCoverage(), v = (FF.health && FF.health.venues && FF.health.venues[FF.venue]) || null;
    if (d) {
      if (c && c.days_with_data) {
        d.textContent = c.sentence || (c.days_with_data + ' day' + (c.days_with_data === 1 ? '' : 's') + ' of data');
        d.title = VENUES[FF.venue].name + ': ' + c.days_with_data + ' day(s) with data' +
          (c.empty_days ? ', ' + c.empty_days + ' day(s) with no trading recorded' : '');
      } else {
        d.textContent = FF.up ? 'checking how much data is held…' : 'data service warming up';
        d.removeAttribute('title');
      }
    }
    if (sub) {
      var bits = [];
      if (c && c.trades) bits.push(fmtN(c.trades) + ' trades recorded');
      if (v && v.last_trade_ts) bits.push('last trade ' + fmtPST(v.last_trade_ts) + ' PST');
      sub.textContent = bits.join(' \u00b7 ');
    }
  }

  /* ------------------------------------------------------------------ warming-up state + retry */
  function setUp(up, why) {
    FF.up = up;
    var pill = $('ffStatusPill'); if (pill) {
      // The pill describes THE TIER (what a signed-out visitor may request), not how much data exists.
      // How much data exists is the #ffVenueDepth line beside it, which is measured, not written here.
      pill.textContent = up ? 'live \u00b7 free 31-day window' : 'data service warming up';
      pill.className = 'ff-pill ' + (up ? 'ff-pill-ok' : 'ff-pill-warm'); pill.title = why || '';
    }
    if (typeof renderVenueDepth === 'function') renderVenueDepth();
    if (!up) scheduleRetry();
  }
  function warmingHtml(extra) {
    return '<div class="ff-warm"><div class="ff-warm-spin"></div><div class="ff-warm-t">Data service warming up</div><div class="ff-warm-s">' + esc(extra || 'The Future Files data API is starting. Retrying automatically') + ' <span class="ff-retry-in"></span></div><button class="ff-btn ff-btn-ghost" onclick="FF.retryNow()">Retry now</button></div>';
  }
  function scheduleRetry() {
    if (FF.retryTimer) return;
    var ms = FF.retryMs; FF.retryMs = Math.min(FF.retryMs * 2, 30000);
    var until = Date.now() + ms;
    FF.retryCountdown = setInterval(function () { var s = Math.max(0, Math.ceil((until - Date.now()) / 1000)); document.querySelectorAll('.ff-retry-in').forEach(function (el) { el.textContent = 'in ' + s + 's…'; }); }, 500);
    FF.retryTimer = setTimeout(function () { FF.retryTimer = null; clearInterval(FF.retryCountdown); if (FF.tab === 'predictions') loadAll(); }, ms);
  }
  FF.retryNow = function () { clearTimeout(FF.retryTimer); FF.retryTimer = null; clearInterval(FF.retryCountdown); FF.retryMs = 5000; loadAll(); };

  /* ------------------------------------------------------------------ the Markets paywall
     (billing 2026-09-28) Market data is part of the $20 a month subscription. A visitor who is not
     entitled sees one card in front of a blurred preview. Every number on it is real and comes
     from the API's public teaser (GET /v1/teaser; /v1/health is the fallback); a figure the API
     does not send is left out. The venue header and the account panel stay usable, because
     signing in happens there. Styles: `.pw-*` at the end of theme.css. */
  var PW = { teaser: null, asked: false, shown: false };
  var PW_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function pwDay(d) { var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(d || ''); return m ? (+m[3]) + ' ' + PW_MONTHS[+m[2] - 1] + ' ' + m[1] : ''; }
  function pwCompact(n) {
    function f(v, u) { var d = v >= 100 ? 0 : v >= 10 ? 1 : 2; return v.toFixed(d).replace(/\.0+$|(\.\d*[1-9])0+$/, '$1') + u; }
    if (n >= 1e9) return f(n / 1e9, 'B'); if (n >= 1e6) return f(n / 1e6, 'M'); if (n >= 1e3) return f(n / 1e3, 'K');
    return String(Math.round(n));
  }
  function pwHeadline(t) {   /* rounded DOWN, so "over" is always true */
    function down(v) { return (Math.floor(v * 10) / 10).toFixed(1).replace(/\.0$/, ''); }
    if (t >= 1e9) return 'Over ' + down(t / 1e9) + ' billion trades';
    if (t >= 1e6) return 'Over ' + down(t / 1e6) + ' million trades';
    return '';
  }
  function pwDays(n) { return n === 1 ? '1 day' : Number(n).toLocaleString('en-US') + ' days'; }
  function pwFromHealth(h) {
    if (h && h.teaser && h.teaser.venues && h.teaser.venues.length) return h.teaser;
    if (!h || !h.venues) return null;
    var out = { trades: 0, venues: [] };
    ['kalshi', 'polymarket'].forEach(function (v) {
      var c = h.venues[v] && h.venues[v].coverage; if (!c || !c.trades) return;
      out.trades += c.trades;
      out.venues.push({ venue: v, name: VENUES[v] ? VENUES[v].name || (v[0].toUpperCase() + v.slice(1)) : v, trades: c.trades,
        trade_days: c.days_with_data, first_day: c.first_day, last_day: c.last_day });
    });
    return out.venues.length ? out : null;
  }
  function pwLoad() {
    if (PW.asked) return; PW.asked = true;
    api('/v1/teaser', { timeout: 8000 }).then(function (t) { if (!t || !t.venues || !t.venues.length) throw new Error('empty'); return t; })
      .catch(function () { return api('/v1/health', { timeout: 8000 }).then(pwFromHealth); })
      .then(function (t) { PW.teaser = t; if (PW.shown) pwDraw(); })
      .catch(function () {});
  }
  function pwArea(series) {
    var W = 600, H = 170, pad = 6, max = 1, i, d = '';
    for (i = 0; i < series.length; i++) max = Math.max(max, series[i].t);
    for (i = 0; i < series.length; i++) d += (i ? ' L' : 'M') + ((i / (series.length - 1)) * W).toFixed(1) + ' ' + (H - pad - (series[i].t / max) * (H - pad * 2)).toFixed(1);
    return '<svg class="pw-chart" viewBox="0 0 ' + W + ' ' + H + '" preserveAspectRatio="none"><path class="pw-chart-fill" d="' + d + ' L' + W + ' ' + H + ' L0 ' + H + ' Z"/><path class="pw-chart-line" d="' + d + '"/></svg>';
  }
  function pwHtml() {
    var t = PW.teaser, by = {}, cols = [], tiles = '', panes = '', rows = '', scopes = [], first = '';
    if (t) t.venues.forEach(function (v) { by[v.venue] = v; });
    ['kalshi', 'polymarket'].forEach(function (k) { if (by[k]) cols.push(by[k]); });
    function tile(l, v) { tiles += '<div class="pw-tile"><span class="pw-tile-l">' + esc(l) + '</span><b class="pw-tile-v">' + esc(v) + '</b></div>'; }
    if (t && t.trades) tile('Trades', pwCompact(t.trades));
    cols.forEach(function (v) {
      if (v.trades) tile(v.name, pwCompact(v.trades));
      if (v.trade_days) tile(v.name + ' history', pwDays(v.trade_days));
      if (v.order_book && v.order_book.days) tile(v.name + ' order books', pwDays(v.order_book.days));
      if (v.daily && v.daily.length > 1) panes += '<div class="pw-pane"><span class="pw-pane-h">' + esc(v.name) + ' \u00b7 trades per day</span>' + pwArea(v.daily) + '</div>';
      if (v.first_day && (!first || v.first_day < first)) first = v.first_day;
      if (v.order_book && v.order_book.days && v.order_book.note) scopes.push(v.name + ': ' + v.order_book.note);
    });
    function row(label, pick) {
      var cells = cols.map(pick), any = false, h = '';
      cells.forEach(function (c) { if (c) any = true; });
      if (!any) return;
      h = '<span class="pw-td pw-rowh">' + esc(label) + '</span>';
      cells.forEach(function (c) { h += '<span class="pw-td' + (c ? '' : ' none') + '">' + esc(c || 'not yet') + '</span>'; });
      rows += h;
    }
    row('Trades', function (v) { return v.trades ? pwCompact(v.trades) : ''; });
    row('Trade history', function (v) { return v.trade_days ? pwDays(v.trade_days) : ''; });
    row('Order books', function (v) { return v.order_book && v.order_book.days ? pwDays(v.order_book.days) : ''; });
    row('Markets', function (v) { return v.markets ? pwCompact(v.markets) : ''; });
    var head = t && t.trades ? pwHeadline(t.trades) : '';
    var table = '';
    if (rows) {
      table = '<div class="pw-facts"><div class="pw-table pw-cols-' + cols.length + '"><span class="pw-th"></span>' +
        cols.map(function (v) { return '<span class="pw-th">' + (v.venue === 'kalshi' ? kalshiMark(16) : polyMark(16)) + esc(v.name) + '</span>'; }).join('') + rows + '</div>' +
        (scopes.length ? '<p class="pw-scope">Order books \u2014 ' + esc(scopes.join('. ')) + '.</p>' : '') + '</div>';
    }
    return '<div class="pw-preview" aria-hidden="true"><div class="pw-tiles">' + tiles + '</div><div class="pw-charts">' + panes + '</div></div>' +
      '<div class="pw-veil" aria-hidden="true"></div>' +
      '<div class="pw-card">' +
        '<div class="pw-eyebrow">Market data</div>' +
        '<h2 class="pw-h">' + esc(head || 'Kalshi and Polymarket market data') + '</h2>' +
        '<p class="pw-sub">' + esc(head && first ? 'Kalshi and Polymarket, recorded since ' + pwDay(first) + '.' : 'Every trade, order books, charts and search.') + '</p>' +
        table +
        '<div class="pw-price"><b>$' + ((t && t.price_usd) || 20) + '</b><span> / month</span></div>' +
        '<button class="pw-go" id="pwGo" type="button">Subscribe</button>' +
        '<p class="pw-note" id="pwNote" role="status"></p>' +
        (signedIn()
          ? '<p class="pw-foot">Signed in' + (AUTH.user && AUTH.user.email ? ' as ' + esc(AUTH.user.email) : '') + '</p>'
          : '<p class="pw-foot">Already subscribed? <button class="pw-link" id="pwSignIn" type="button">Sign in</button></p>') +
      '</div>';
  }
  function pwDraw() {
    var el = $('ffPaywall'); if (!el) return;
    el.innerHTML = pwHtml();
    var go = $('pwGo'), si = $('pwSignIn');
    if (go) go.addEventListener('click', function () {
      go.disabled = true; go.textContent = 'Opening checkout\u2026';
      authFetch('/v1/stripe/checkout', { body: { product: 'markets' }, timeout: 15000 })
        .then(function (r) { if (r && r.url) { if (typeof window.ffLeave === 'function') window.ffLeave(r.url); else window.location.href = r.url; } else throw new Error('no url'); })
        .catch(function () {
          go.disabled = false; go.textContent = 'Subscribe';
          var n = $('pwNote'); if (n) { n.textContent = 'Checkout could not be opened. Try again in a moment.'; n.className = 'pw-note bad'; }
        });
    });
    if (si) si.addEventListener('click', function () { openAccount(); var mc = $('mainContainer'); if (mc) mc.scrollTop = 0; });
  }
  function pwShow() {
    var root = $('ffPredictions'); if (!root) return;
    var el = $('ffPaywall');
    if (!el) { el = document.createElement('section'); el.id = 'ffPaywall'; el.className = 'pw'; el.setAttribute('aria-label', 'Market data subscription'); root.appendChild(el); }
    root.classList.add('ff-paywalled');
    PW.shown = true;
    var pill = $('ffStatusPill'); if (pill) pill.hidden = true;
    pwDraw(); pwLoad();
  }
  function pwHide() {
    var root = $('ffPredictions'), el = $('ffPaywall');
    if (el && el.parentNode) el.parentNode.removeChild(el);
    if (root) root.classList.remove('ff-paywalled');
    var pill = $('ffStatusPill'); if (pill) pill.hidden = false;
    PW.shown = false;
  }
  /* True when the dashboard may load. The first answer waits for the session restore, so a
     subscriber reloading the page is not shown the card for a moment. */
  function paywallPass() {
    if (proActive()) { if (PW.shown) pwHide(); return true; }
    if (AUTH.ready && !PW.settled) {
      AUTH.ready.then(function () { PW.settled = true; if (FF.tab === 'predictions') loadAll(); });
      return false;
    }
    pwShow();
    return false;
  }
  function paywallSync() {
    if (FF.tab !== 'predictions' || !$('ffPredictions')) return;
    if (proActive() && PW.shown) { pwHide(); loadAll(); }
    else if (!proActive() && PW.settled && !PW.shown) pwShow();
    else if (PW.shown) pwDraw();
  }

  /* ------------------------------------------------------------------ data loading */
  var DATA = { summary: null, ts: null, heat: null, cats: null };
  function loadAll() {
    if (FF.tab !== 'predictions') return;
    if (!paywallPass()) return;   /* billing 2026-09-28: market data is part of the subscription */
    /* a new load answers whatever the last blocked-chip note was complaining about */
    var cov = $('ffCoverage'); if (cov) { cov.hidden = true; cov.innerHTML = ''; }
    applyTierToSelection();
    var body = $('ffChartBody'); if (body && !FF.up) body.innerHTML = warmingHtml();
    var stats = $('ffStats'); if (stats && !stats.children.length) stats.innerHTML = statsHtml(null);
    api('/v1/health', { timeout: 6000 }).then(function (h) {
      setUp(true); FF.retryMs = 5000;
      /* The SERVER owns the interval ladder (/v1/health -> tiers.granularities); the table in this
         file is only the cold-start fallback. `|| isProBucket(...)` and not plain `g.pro`: the
         server may ADD a lock, never drop one — a health payload that forgot to mark 1m pro is how
         the chip came unlocked on BTC. */
      if (h && h.tiers && h.tiers.granularities && h.tiers.granularities.length) {
        INTERVALS = h.tiers.granularities.map(function (g) {
          var short = { tick: 'Tick', '1m': '1m', '5m': '5m', '15m': '15m', '1h': '1h', '1d': '1d', '3M': '3M' }[g.bucket] || g.bucket;
          return { v: g.bucket, label: g.label, short: short, sec: g.seconds, pro: !!g.pro || isProBucket(g.bucket), maxDays: g.max_days };
        });
        var group = $('ffInterval');
        if (group && group.dataset.built !== '1') { group.innerHTML = intervalChips(); group.dataset.built = '1'; wireIntervalButtons(); }
        applyTierToSelection(); syncChips();
      }
      FF.health = h;
      renderVenueDepth();
      return Promise.all([
        DATA.cats ? null : authFetch('/v1/' + FF.venue + '/categories').then(function (c) { DATA.cats = c; fillCats(c); }).catch(function () {}),
        authFetch('/v1/' + FF.venue + '/summary').then(function (s) { DATA.summary = s; }).catch(function () {}),
        loadSeriesData()
      ]);
    }).then(function () { renderStats(); renderChart(); })
      .catch(function (e) { setUp(false, String(e)); renderStats(); if (body) body.innerHTML = warmingHtml(); });
  }
  /* base timeseries (used by line/bars/table, and as the pts fallback-gate for heatmap). Fetched once per
     loadAll() call — i.e. on an explicit venue/category/series/metric/range/side change, or tab open —
     never from renderChart, so a resize or a mode switch never triggers a new fetch here. */
  function loadSeriesData() {
    var r = rangeDates(), sc = scope();
    DATA.tsErr = null;
    return authFetch('/v1/' + FF.venue + '/timeseries?' + qs(Object.assign({ metric: apiMetric(), side: FF.side, bucket: r.bucket, from: r.from, to: r.to }, sc))).then(function (t) { DATA.ts = t; }).catch(function (e) { DATA.ts = null; DATA.tsErr = e; });
  }
  /* The SIDE chip and the PRICE metric ask different questions of the same trades:
       side=yes|no|both  WHOSE trades are counted (the taker bought YES, bought NO, or all of them)
       price_yes/price_no  WHICH SCALE the average price is quoted on
     They are independent, so a price chart with side=no is the mean price of the trades where the
     taker bought NO. With no side picked the scale stays the yes scale, which is how a prediction
     market quotes itself. */
  function apiMetric() { return FF.metric === 'price' ? (FF.side === 'no' ? 'price_no' : 'price_yes') : FF.metric; }
  /* heatmap extra data: fetched lazily and on demand from renderChart (only the heatmap needs a
     second, hourly series), guarded so it is never fetched twice at once and never retried without a delay.
     CHART_LOAD/ensureExtra below is the actual fix for the /v1/<venue>/timeseries 429 loop — see there. */
  function chartExtraKey() { return [FF.venue, FF.category, FF.series, FF.metric, FF.range, FF.customFrom, FF.customTo, FF.side].join('|'); }
  function fetchExtra(mode) {
    var r = rangeDates(), sc = scope(), key = chartExtraKey();
    return authFetch('/v1/' + FF.venue + '/timeseries?' + qs(Object.assign({ metric: apiMetric(), side: FF.side, bucket: '1h', from: r.from, to: r.to }, sc))).then(function (t) { DATA.heat = t; DATA.heatKey = key; });
  }
  /* ROOT CAUSE of the 429 loop: the old code did
       if (mode needs data && !have it) { loadSeriesData().then(renderChart); ...spinner...; return; }
     inside renderChart() itself, with NO delay and NO retry cap. Every re-render — including the
     window-resize handler firing every ~150ms while a visitor dragged the window, and every immediate
     re-render right after a failed fetch — re-entered this branch and fired a brand-new request the
     instant the previous one settled. On a failure (e.g. a 429) the promise resolves fast, so this
     produced a tight zero-delay retry loop hammering /v1/<venue>/timeseries (heatmap mode issues it at
     both the page's normal bucket AND a 1h bucket — "1h+1d" — doubling the flood) until the IP got
     rate-limited, and then kept retrying into more 429s forever. */
  var CHART_LOAD = {
    heatmap: { key: '', tries: 0, timer: null, inFlight: false, terminal: false, err: null }
  };
  function ensureExtra(mode) {
    var st = CHART_LOAD[mode], key = chartExtraKey();
    if (st.key !== key) { clearTimeout(st.timer); CHART_LOAD[mode] = st = { key: key, tries: 0, timer: null, inFlight: false, terminal: false, err: null }; }
    if (st.inFlight || st.timer || st.terminal) return; /* dedupe: already loading, already backing off, or exhausted — a re-render (resize, hover, mode toggle) never starts another fetch */
    st.inFlight = true;
    fetchExtra(mode).then(function () {
      st.inFlight = false; st.tries = 0; st.err = null; renderChart();
    }).catch(function (e) {
      st.inFlight = false; st.err = e; st.tries++;
      if (st.tries >= 3) { st.terminal = true; renderChart(); return; } /* never auto-retry more than 3 times */
      var waitMs = (e && e.status === 429 && e.retryAfter) ? Math.max(1000, e.retryAfter * 1000) : [5000, 15000, 60000][st.tries - 1];
      st.timer = setTimeout(function () { st.timer = null; renderChart(); }, waitMs); /* honor Retry-After, else 5s/15s/60s backoff */
      renderChart();
    });
  }
  FF.retryChart = function (mode) { var st = CHART_LOAD[mode]; if (st) { clearTimeout(st.timer); st.tries = 0; st.terminal = false; st.timer = null; st.err = null; } renderChart(); };
  function fillCats(c) { var sel = $('ffCat'); if (!sel) return; sel.innerHTML = '<option value="">All categories</option>' + (c || []).map(function (x) { return '<option value="' + esc(x.category) + '">' + esc(x.category) + ' (' + fmtN(x.trades_30d) + ')</option>'; }).join(''); sel.value = FF.category; }

  function statsHtml(s) {
    var v = function (k) { return s ? s[k] : '—'; };
    return [['Trades', v('trades')], ['Contracts', v('contracts')], ['Notional', v('notional')], ['Active markets', v('active')], ['Window', v('days')]].map(function (x) { return '<div class="ff-stat"><div class="ff-stat-l">' + x[0] + '</div><div class="ff-stat-v">' + esc(x[1]) + '</div></div>'; }).join('');
  }
  function renderStats() {
    var el = $('ffStats'); if (!el) return;
    var S = DATA.summary, r = rangeDates();
    if (!S || !S.days) { el.innerHTML = statsHtml(null); return; }
    var days = S.days.filter(function (d) { var ms = new Date(d.date).getTime(); return ms >= r.fromMs - 86400000 && ms <= r.toMs + 86400000; });
    var t = 0, c = 0, n = 0, a = 0; days.forEach(function (d) { t += +d.trades || 0; c += +d.contracts || 0; n += +d.notional_usd || 0; a = Math.max(a, +d.active_markets || 0); });
    el.innerHTML = statsHtml({ trades: fmtN(t), contracts: fmtN(c), notional: fmtUSD(n), active: fmtN(a), days: r.days + (r.days === 1 ? ' day' : ' days') });
  }
  function bandFilter(bins) {
    if (FF.band === 'all') return bins;
    var p = FF.band.split('-').map(Number);
    return bins.filter(function (b) { return b.hi > p[0] && b.lo < p[1]; });
  }
  function renderChart() {
    var body = $('ffChartBody'), title = $('ffChartTitle'), sub = $('ffChartSub'); if (!body) return;
    if (!FF.up) { body.innerHTML = warmingHtml(); return; }
    if (FF.mode === 'heatmap') {
      var key = chartExtraKey();
      var have = !!DATA.heat && DATA.heatKey === key;
      if (!have) {
        var st = CHART_LOAD[FF.mode];
        var is429 = st.err && st.err.status === 429;
        if (st.key === key && st.terminal) {
          body.innerHTML = '<div class="ff-empty">' + (is429 ? 'The data service is rate-limiting requests right now.' : 'Could not load this chart' + (st.err ? ' (' + esc(errText(st.err)) + ')' : '') + '.') + ' <button class="ff-btn ff-btn-ghost" onclick="FF.retryChart(\'' + FF.mode + '\')">' + (is429 ? 'Rate limited' : 'Failed') + ' &mdash; retry</button></div>';
        } else if (st.key === key && st.timer) {
          body.innerHTML = '<div class="ff-warm"><div class="ff-warm-spin"></div><div class="ff-warm-s">' + (is429 ? 'Rate limited by the data service' : 'Data service temporarily unavailable') + ' — retrying automatically…</div></div>';
        } else {
          body.innerHTML = '<div class="ff-warm"><div class="ff-warm-spin"></div></div>';
        }
        ensureExtra(FF.mode);
        return;
      }
    }
    var V = VENUES[FF.venue], scopeTxt = FF.series || FF.category || 'all markets';
    var fmt = FF.metric === 'notional' ? fmtUSD : (FF.metric === 'price' ? function (v) { return (+v).toFixed(0) + '¢'; } : fmtN);
    var sideTxt = FF.side === 'both' ? '' : ' · taker ' + FF.side.toUpperCase();
    var label = { trades: 'Trades', contracts: 'Contracts', notional: 'Notional (USD)', price: 'Price ' + (FF.side === 'no' ? 'NO' : 'YES') + ' (¢)' }[FF.metric] + sideTxt;
    var pts = (DATA.ts && DATA.ts.points) || [];
    if (!pts.length && DATA.summary && DATA.summary.days && !FF.series && !FF.category && FF.metric !== 'price') {
      var key = { trades: 'trades', contracts: 'contracts', notional: 'notional_usd' }[FF.metric];
      pts = DATA.summary.days.map(function (d) { return { t: d.date, v: +d[key] || 0 }; });
    }
    var r = rangeDates(); var cutoff = r.fromMs;
    pts = pts.filter(function (p) { var ms = new Date(p.t).getTime(); return ms >= cutoff - 3600000 && ms <= r.toMs + 3600000; }).sort(function (a, b) { return new Date(a.t) - new Date(b.t); });
    /* Anything finer than a day gets a time-of-day label; a day or coarser gets a date. */
    var gDef = interval(r.bucket), fine = (gDef.sec || 0) < 86400;
    var x = pts.map(function (p) { return fine ? fmtPST(p.t) : fmtDay(p.t); }), y = pts.map(function (p) { return +p.v || 0; });
    title.textContent = V.name + ' · ' + label + ' · ' + scopeTxt;
    sub.textContent = (FF.range === 'custom' ? r.days + (r.days === 1 ? ' day' : ' days') : 'last ' + FF.range) +
      ' · ' + (FF.mode === 'heatmap' ? '1 hour intervals' : gDef.label) + (proActive() ? ' · Pro' : ' · free tier');
    renderCoverage(FF.mode === 'heatmap' ? DATA.heat : DATA.ts);
    if (!pts.length && FF.mode !== 'heatmap') { body.innerHTML = '<div class="ff-empty">' + (DATA.tsErr && DATA.tsErr.status === 429 ? 'The data service is rate-limiting requests right now \u2014 try again in a few seconds.' : 'No data returned for this selection.' + (DATA.tsErr ? ' (' + esc(errText(DATA.tsErr)) + ')' : '')) + '</div>'; return; }
    if (FF.mode === 'line') chartLine(body, x, [{ name: label, y: y }], { fmt: fmt });
    else if (FF.mode === 'bars') chartBars(body, x, y, { fmt: fmt });
    else if (FF.mode === 'table') body.innerHTML = tableHtml(['Time (PST)', label], pts.map(function (p, i) { return [x[i], fmt(p.v)]; }));
    else if (FF.mode === 'heatmap') {
      var hp = ((DATA.heat && DATA.heat.points) || []).filter(function (p) { return new Date(p.t).getTime() >= cutoff; });
      var dayKeys = [], grid = {};
      hp.forEach(function (p) { var d = new Date(p.t); var dk = d.toLocaleDateString('en-US', { timeZone: 'America/Los_Angeles', month: 'short', day: 'numeric' }); var hr = +d.toLocaleString('en-US', { timeZone: 'America/Los_Angeles', hour: 'numeric', hour12: false }) % 24; if (!grid[dk]) { grid[dk] = new Array(24).fill(0); dayKeys.push(dk); } grid[dk][hr] += +p.v || 0; });
      if (!dayKeys.length) { body.innerHTML = '<div class="ff-empty">No hourly data for a heatmap yet.</div>'; return; }
      title.textContent = V.name + ' · ' + label + ' by hour (PST) · ' + scopeTxt;
      chartHeat(body, dayKeys, Array.from({ length: 24 }, function (_, i) { return i; }), dayKeys.map(function (k) { return grid[k]; }), fmt);
    }
  }

  /* ------------------------------------------------------------------ backtest */
  function runBacktest() {
    var out = $('ffBtOut'), btn = $('btRun');
    var sc = $('btScope').value.trim();
    /* Exit is "settle" or a cent price. "Sell at custom ¢" sends the number the visitor typed, so
       the backtest genuinely runs at that exit; the API accepts exit as "settle" | <cents>. A blank
       or out-of-range box REFUSES with a visible message rather than quietly sending garbage. */
    var exitSel = $('btExit').value, exitVal;
    if (exitSel === 'settle') exitVal = 'settle';
    else if (exitSel === 'custom') {
      var raw = String($('btExitC').value || '').trim();
      var c = Number(raw);
      if (raw === '' || !isFinite(c) || c !== Math.round(c) || c < 1 || c > 99) {
        out.innerHTML = '<div class="ff-empty">Enter the exit price as a whole number of cents between 1 and 99 — that box is ' + (raw === '' ? 'empty' : 'set to ' + esc(raw)) + '.</div>';
        $('btExitC').focus(); return;
      }
      exitVal = c;
    } else exitVal = +exitSel;
    var body = { venue: FF.venue, side: $('btSide').value, entry_c: +$('btEntry').value || 20, exit: exitVal, from: $('btFrom').value, to: $('btTo').value, size: 1 };
    if (sc) { if (/^[A-Z0-9]{3,}[-A-Z0-9]*$/.test(sc)) body.series = sc; else body.category = sc.toLowerCase(); }
    btn.disabled = true; btn.textContent = 'Running…';
    out.innerHTML = '<div class="ff-warm"><div class="ff-warm-spin"></div></div>';
    authFetch('/v1/backtest', { body: body, timeout: 30000 }).then(function (r) {
      var eq = r.equity_curve || [];
      var html = '<div class="ff-btstats">' + [['Markets', fmtN(r.n_markets)], ['Fills', fmtN(r.n_fills)], ['Win rate', ((+r.win_rate || 0) * (r.win_rate <= 1 ? 100 : 1)).toFixed(1) + '%'], ['P&L', fmtUSD(r.pnl_usd)], ['Avg / contract', (+r.avg_pnl_per_contract_c || 0).toFixed(2) + '¢']].map(function (x) { return '<div class="ff-stat"><div class="ff-stat-l">' + x[0] + '</div><div class="ff-stat-v">' + x[1] + '</div></div>'; }).join('') + '</div>';
      html += '<div id="ffBtEq" class="ff-chartbody ff-chartbody-sm"></div>';
      if (r.by_series && r.by_series.length) { var cols = Object.keys(r.by_series[0]).slice(0, 6); html += tableHtml(cols, r.by_series.slice(0, 25).map(function (row) { return cols.map(function (c) { return typeof row[c] === 'number' ? (Math.round(row[c] * 100) / 100) : row[c]; }); })); }
      out.innerHTML = html;
      if (eq.length) chartLine($('ffBtEq'), eq.map(function (p) { return fmtDay(p.t); }), [{ name: 'Equity (USD)', y: eq.map(function (p) { return +p.pnl_usd || 0; }) }], { h: 200, fmt: fmtUSD }); else $('ffBtEq').innerHTML = '<div class="ff-empty">No equity curve returned.</div>';
    }).catch(function (e) {
      out.innerHTML = (e && e.status) ? '<div class="ff-empty">Backtest failed: ' + esc(errText(e)) + '</div>' : warmingHtml('Backtest engine unavailable right now. Retrying automatically');
      if (!(e && e.status)) setUp(false, String(e));
    }).finally(function () { btn.disabled = false; btn.textContent = 'Run backtest'; });
  }

  /* ------------------------------------------------------------------ pro / stripe / live
   * The Pro card is a BUY BUTTON or a CANCEL LINK, and nothing else.
   *
   * It used to carry a ticker box, "Load ticks", "Start live", a scrolling live feed and a
   * paragraph of billing prose — raw developer controls for endpoints the product already calls on
   * its own, sitting in the exact place a visitor decides whether to pay $20. The CAPABILITY is
   * untouched: GET /v1/{venue}/ticks and WS /v1/live still exist, the subscription still unlocks
   * them, and the market view is what spends them. Only these controls are gone.
   *
   * Redeeming an old device token moved to the Account panel, where "I already have Pro" belongs
   * and where the desktop app has always kept it. */
  function renderPro() {
    paywallSync();                /* billing 2026-09-28: entitlement may just have changed */
    var el = $('ffPro'); if (!el) return;
    if (!proActive()) {
      /* What the $20 buys, said in four lines, in the theme's existing `.ff-pro-lock` idiom (the
         green tick list). The minute-bar line is the one that matters after 2026-09-26: the free
         floor is FIVE-MINUTE bars, and 1m is no longer free on any series or any venue. */
      el.innerHTML = proHead('Pro', '<span class="ff-pro-tag">$20/month</span>') +
        '<div class="ff-pro-lock">' +
          '<div class="ff-pro-glyph"><i class="fas fa-lock"></i></div>' +
          '<p>Every tick, every minute, and a quarter of history.</p>' +
          '<ul>' +
            '<li>Every tick — each individual market movement, not a bar</li>' +
            '<li>1-minute bars. Free goes down to 5 minutes; a minute bar is Pro</li>' +
            '<li>3 months of history instead of a rolling 31 days</li>' +
            '<li>The live trade + top-of-book relay</li>' +
          '</ul>' +
        '</div>' +
        '<div class="ff-pro-simple">' +
          '<button class="ff-btn ff-btn-big ff-pro-signin" id="ffUpgrade">Subscribe &mdash; $20/month</button>' +
          '<div id="ffUpgradeMsg" class="ff-muted"></div>' +
        '</div>';
      $('ffUpgrade').addEventListener('click', upgrade);
      return;
    }
    el.innerHTML = proHead('Pro', '<span class="ff-pro-tag ff-pro-tag-on">Active</span>') +
      '<div class="ff-pro-simple">' +
        '<div class="ff-muted" id="ffProWho"></div>' +
        '<button class="ff-btn ff-btn-ghost" id="ffManage">Manage subscription</button>' +
        '<div id="ffManageMsg" class="ff-muted"></div>' +
      '</div>';
    $('ffManage').addEventListener('click', function () { managePortal('ffManage', 'ffManageMsg'); });
    authFetch('/v1/me').then(function (me) {
      var t = $('ffProWho'); if (t && me) t.textContent = me.email || '';
      if (me && me.entitlement && signedIn()) AUTH.ent = me.entitlement;
    }).catch(function () {});
  }
  function proHead(title, tag) {
    return '<div class="ff-card-head"><span><i class="fas fa-bolt" style="color:var(--ff-orange)"></i> ' + esc(title) + '</span>' + tag + '</div>';
  }
  function upgrade() {
    var b = $('ffUpgrade'), m = $('ffUpgradeMsg'); b.disabled = true; b.textContent = 'Opening checkout…';
    /* authFetch, so that a signed-in buyer's Checkout Session carries client_reference_id=user_<id>
       and the webhook attaches the subscription to the ACCOUNT, not to an anonymous device. */
    authFetch('/v1/stripe/checkout', { body: {} , timeout: 15000 }).then(function (r) { if (r && r.url) { if (typeof window.ffLeave === 'function') window.ffLeave(r.url); else window.location.href = r.url; } else throw new Error('no url'); })
      .catch(function (e) { b.disabled = false; b.innerHTML = '<i class="fas fa-arrow-up"></i> Upgrade'; m.textContent = 'Checkout unavailable right now (' + errText(e) + '). Please try again shortly.'; });
  }
  /* Stripe customer portal: a short-lived session URL, so it is fetched at click time and the
     browser is sent straight to it. Stripe returns the visitor to ?portal=return (see below). */
  function managePortal(btnId, msgId) {
    var b = $(btnId || 'ffManage'), m = $(msgId || 'ffManageMsg'); if (!b) return;
    b.disabled = true; b.textContent = 'Opening Stripe\u2026'; if (m) m.textContent = '';
    authFetch('/v1/stripe/portal?client=web', { timeout: 15000 })
      .then(function (r) { if (r && r.url) { if (typeof window.ffLeave === 'function') window.ffLeave(r.url); else window.location.href = r.url; } else throw new Error('no url'); })
      .catch(function (e) {
        b.disabled = false; b.innerHTML = '<i class="fas fa-gear"></i> Manage subscription';
        if (!m) return;
        if (e && e.status === 409 && AUTH.ent && AUTH.ent.pro && AUTH.ent.source && AUTH.ent.source !== 'stripe') m.textContent = 'This account\u2019s Pro was granted, not bought through Stripe \u2014 there is nothing to bill or cancel.';
        else if (e && (e.status === 404 || e.status === 409)) m.textContent = 'This Pro access is not linked to a Stripe customer \u2014 email hello@thefuturefiles.com and we will cancel it for you.';
        else m.textContent = 'Billing page unavailable right now (' + errText(e) + '). Please try again shortly.';
      });
  }
  /* Back from Stripe Checkout. This runs on the HOME page — `/?tab=predictions&session_id=cs_…` is
     the URL that works (`/pages/pro` does not exist and 404s), and boot() already forces the
     predictions tab when it sees a session_id. */
  function handleStripeReturn() {
    var u; try { u = new URL(window.location.href); } catch (e) { return; }
    var sid = u.searchParams.get('session_id'); if (!sid) return;
    api('/v1/stripe/session?session_id=' + encodeURIComponent(sid), { timeout: 15000 }).then(function (r) {
      if (r && r.tff_token) setToken(r.tff_token);
      u.searchParams.delete('session_id'); history.replaceState(null, '', u.pathname + (u.search || '') + u.hash);
      window.ffShowTab('predictions', { force: true });
      /* Attach the purchase to the account as well, so it is Pro on every device they sign in on
         and not only in this browser. Waits for the session restore to have settled. */
      (AUTH.ready || Promise.resolve()).then(function () {
        if (!signedIn()) return;
        return authFetch('/v1/auth/claim', { body: { session_id: sid }, timeout: 15000 })
          .then(function (c) { if (c && c.entitlement) AUTH.ent = c.entitlement; return loadMe(); })
          .catch(function () {});
      });
    }).catch(function () { var p = $('ffStatusPill'); if (p) p.textContent = 'could not verify checkout — retry later'; });
  }

  /* Back from the Stripe customer portal. Anything may have changed there \u2014 card, email or a
     cancellation \u2014 so the Pro card is re-rendered, which re-reads /v1/me. */
  function handlePortalReturn() {
    var u; try { u = new URL(window.location.href); } catch (e) { return; }
    if (u.searchParams.get('portal') !== 'return') return;
    u.searchParams.delete('portal'); history.replaceState(null, '', u.pathname + (u.search || '') + u.hash);
    (AUTH.ready || Promise.resolve()).then(function () { if (signedIn()) loadMe().catch(function () {}); });
    if (!proActive()) return;
    renderPro();
    var m = $('ffManageMsg') || $('ffAcctManageMsg'); if (m) m.textContent = 'Your subscription settings were saved with Stripe.';
  }

  /* ------------------------------------------------------------------ AI search */
  function ask() {
    var q = ($('searchInput') && $('searchInput').value.trim()) || ''; if (!q) return;
    try { if (typeof updateSearchUI === 'function') updateSearchUI(); } catch (e) {}
    var panel = $('ffAskPanel'); if (!panel) { renderVenue(); panel = $('ffAskPanel'); }
    panel.hidden = false; FF.lastAsk = q; saveHistory(q); hideHistory();
    panel.innerHTML = '<div class="ff-ask-q"><i class="fas fa-magic"></i> ' + esc(q) + '</div><div class="ff-warm"><div class="ff-warm-spin"></div><div class="ff-warm-t">Searching the data…</div></div>';
    var mc = $('mainContainer'); if (mc) mc.scrollTop = 0;
    authFetch('/v1/ask', { body: { q: q, venue: FF.venue }, timeout: 45000 }).then(function (r) {
      var html = '<div class="ff-ask-q"><i class="fas fa-magic"></i> ' + esc(q) + '<button class="ff-ask-x" onclick="document.getElementById(\'ffAskPanel\').hidden=true" title="Close">&times;</button></div>';
      html += '<div class="ff-md">' + mdLite(r.answer_md || '') + '</div>';
      if (r.chart && r.chart.x) html += '<div class="ff-card-head"><span>' + esc(r.chart.title || '') + '</span></div><div id="ffAskChart" class="ff-chartbody ff-chartbody-sm"></div>';
      if (r.table && r.table.columns) html += tableHtml(r.table.columns, (r.table.rows || []).slice(0, 200));
      if (r.plan && r.plan.endpoint) html += '<div class="ff-muted ff-plan">plan: ' + esc(r.plan.endpoint) + ' ' + esc(JSON.stringify(r.plan.params || {})) + (r.plan.calls && r.plan.calls.length > 1 ? ' (+' + (r.plan.calls.length - 1) + ' more calls)' : '') + '</div>';
      if (r.intent && r.intent.intent) html += '<div class="ff-ask-src">Answered by The Future Files data engine' + (r.intent.source && r.intent.source.indexOf('ollama') === 0 ? ' with a local model (' + esc(r.intent.source.slice(7)) + ')' : ' (rule-based, no external AI)') + ' · intent: ' + esc(r.intent.intent) + '</div>';
      panel.innerHTML = html;
      if (r.chart && r.chart.x) {
        var c = r.chart, el = $('ffAskChart'); var s = (c.series || []).map(function (s) { return { name: s.name, y: (s.y || []).map(Number) }; });
        if (c.type === 'line') chartLine(el, c.x, s.length ? s : [{ name: '', y: [] }], { h: 220 }); else chartBars(el, c.x, (s[0] && s[0].y) || [], { h: 220 });
      }
    }).catch(function (e) {
      panel.innerHTML = '<div class="ff-ask-q"><i class="fas fa-magic"></i> ' + esc(q) + '<button class="ff-ask-x" onclick="document.getElementById(\'ffAskPanel\').hidden=true" title="Close">&times;</button></div>' + (e.status ? '<div class="ff-empty">The AI search returned ' + esc(errText(e)) + '.</div>' : warmingHtml('Search is part of the data service, which is still starting. Retrying automatically'));
      if (!e.status) setUp(false, String(e));
    });
  }
  window.ffAsk = ask;

  /* ------------------------------------------------------------------ footer player (custom orange controls bound to #audioElement) */
  function initPlayer() {
    var p = $('audioElement'), scrub = $('ffScrub'), cur = $('ffCur'), dur = $('ffDur'), btn = $('ffPlayBtn'), vol = $('ffVol'), mute = $('ffMuteBtn'), status = $('ffPlayerStatus');
    if (!p || !scrub) return;
    function ft(s) { if (!isFinite(s) || isNaN(s)) return '0:00'; s = Math.floor(s); var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), x = s % 60; return (h ? h + ':' + String(m).padStart(2, '0') : m) + ':' + String(x).padStart(2, '0'); }
    function paint() { var pct = p.duration ? (p.currentTime / p.duration) * 100 : 0; scrub.value = Math.round(pct * 10); scrub.style.setProperty('--p', pct + '%'); cur.textContent = ft(p.currentTime); dur.textContent = ft(p.duration); }
    function icon() { var i = btn.querySelector('i'); i.className = 'fas ' + (p.paused ? 'fa-play' : 'fa-pause'); btn.classList.toggle('is-playing', !p.paused); }
    function st(t) { if (status) { status.textContent = t || ''; status.hidden = !t; } }
    p.addEventListener('timeupdate', paint); p.addEventListener('durationchange', paint); p.addEventListener('loadedmetadata', function () { paint(); st(''); });
    p.addEventListener('play', icon); p.addEventListener('pause', icon); p.addEventListener('playing', function () { icon(); st(''); });
    p.addEventListener('loadstart', function () { if (p.src && p.src !== window.location.href) st('Connecting to archive.org…'); });
    p.addEventListener('waiting', function () { st('Buffering…'); });
    p.addEventListener('stalled', function () { if (p.readyState < 2) st('Waiting for archive.org… (slow host, up to ~30s)'); });
    p.addEventListener('error', function () { if (p.src && p.src !== window.location.href) st('Trying another archive.org host…'); else st(''); });
    p.addEventListener('emptied', function () { paint(); icon(); st(''); });
    window.ffSeek = function (v) { if (p.duration) p.currentTime = (v / 1000) * p.duration; };
    window.ffSetVolume = function (v) { p.volume = v / 100; p.muted = false; mute.querySelector('i').className = 'fas ' + (v == 0 ? 'fa-volume-mute' : v < 50 ? 'fa-volume-down' : 'fa-volume-up'); };
    window.ffToggleMute = function () { p.muted = !p.muted; mute.querySelector('i').className = 'fas ' + (p.muted ? 'fa-volume-mute' : 'fa-volume-up'); };
    vol.value = 100; paint(); icon();
  }

  /* ------------------------------------------------------------------ capture / verification hooks
   * The same hooks the desktop app carries, so a screenshot proves a CONTROL rather than a stub:
   * everything here goes through the functions a click goes through.
   *   ?mkopen=1            open the Markets group and show the markets view
   *   ?mkvenue=polymarket  select a venue (same as ?venue=)
   *   ?mkrange=7d|3m|custom  ?mkfrom=&mkto=   ?mkint=5m   ?mkmetric=price   ?mkmode=line
   *   ?mkexit=custom&mkexitc=63   choose the backtest exit + its cent box
   *   ?mkhover=0.6         draw the chart crosshair 60% of the way across
   * `?mkhover=` is the one that makes the crosshair verifiable: it calls el.__ffHoverAt(), which is
   * the identical code path a real pointer takes. */
  function applyCaptureQuery() {
    var u; try { u = new URL(window.location.href); } catch (e) { return; }
    var q = u.searchParams, any = false;
    function g(k) { return q.get(k); }
    if (g('mkopen') || g('mkhover') != null || g('mkint') || g('mkrange') || g('mkseries') || g('mkmetric') || g('mkmode') || g('mkexit')) any = true;
    if (!any) return;
    if (g('mkvenue') && VENUES[g('mkvenue')]) FF.venue = g('mkvenue');
    if (g('mkmetric')) FF.metric = g('mkmetric');
    if (g('mkmode')) FF.mode = g('mkmode');
    if (g('mkseries')) FF.series = g('mkseries');
    if (g('mkfrom')) FF.customFrom = g('mkfrom');
    if (g('mkto')) FF.customTo = g('mkto');
    setMarketsOpen(true);
    window.ffShowTab('predictions', { force: true, silent: true });
    if (g('mkseries')) { var si = $('ffSeries'); if (si) si.value = g('mkseries'); }
    if (g('mkrange')) pickRange(g('mkrange'));
    if (g('mkint')) pickInterval(g('mkint'));
    if (g('mkexit')) {
      var bx = $('btExit'); if (bx) { bx.value = g('mkexit'); $('btExitCWrap').hidden = bx.value !== 'custom'; }
      if (g('mkexitc') && $('btExitC')) $('btExitC').value = g('mkexitc');
    }
    syncChips();
    var hv = g('mkhover');
    if (hv != null) {
      /* The chart is drawn by loadAll's promise chain, and on a cold API it is drawn again after a
         retry — so try repeatedly until __ffHoverAt exists, then keep re-asserting it briefly in
         case a later render replaced the SVG under us. */
      var tries = 0;
      var iv = setInterval(function () {
        tries++;
        var b = $('ffChartBody');
        if (b && b.__ffHoverAt) { b.__ffHoverAt(parseFloat(hv)); if (tries > 40) clearInterval(iv); }
        else if (tries > 60) clearInterval(iv);
      }, 400);
    }
  }

  /* ------------------------------------------------------------------ boot */
  function boot() {
    initPlayer();
    setMarketsOpen(marketsOpen());  /* closed unless this session opened it */
    var u; try { u = new URL(window.location.href); } catch (e) {}
    var venue = u && u.searchParams.get('venue'); if (venue && VENUES[venue]) FF.venue = venue;
    var qtab = u && u.searchParams.get('tab');
    /* 10-02 (operator 5:59 PM PST): the home page opens on the DVD/Blu-rays tab. ?tab=episodes (and the
       episode list's own links: ?archives=, ?search=, ?q=, ?ep=, ?id=) open the episodes. */
    var epLink = u && ['archives', 'search', 'q', 'ep', 'id', 't'].some(function (k) { return u.searchParams.has(k); });
    var pathTab = window.ffPathTab(window.location.pathname);
    var want = pathTab ? pathTab : (u && u.searchParams.get('view')) ? 'page' : (qtab === 'predictions' || (u && (u.searchParams.get('session_id') || u.searchParams.get('portal')))) ? 'predictions'
      : (qtab === 'email' ? 'email' : qtab === 'app' ? 'app' : (qtab === 'discs' || qtab === 'dvds' || qtab === 'store') ? 'discs'
      : (qtab === 'episodes' || epLink) ? 'episodes' : 'episodes');
    /* The handoff code lives in the URL FRAGMENT, so a #auth_code also means "go to predictions". */
    var frag = window.location.hash || '';
    if (frag.indexOf('auth_code') >= 0 || frag.indexOf('auth_error') >= 0) want = 'predictions';
    authBoot();
    if (want === 'predictions' && window.ffAtHome()) window.ffShowTab('predictions', { force: true, silent: true });
    else if (want === 'email' && window.ffAtHome()) window.ffShowTab('email', { force: true, silent: true });
    else if (want === 'app' && window.ffAtHome()) window.ffShowTab('app', { force: true, silent: true });
    else if (want === 'discs' && window.ffAtHome()) window.ffShowTab('discs', { force: true, silent: true });
    else if (want === 'page' && typeof window.ffShellHome === 'function') window.ffShellHome(new URL(window.location.href), { history: 'none' });
    else window.ffShowTab('episodes', { silent: true });
    /* the redirects Shopify does for /playlists (/playlist) and /market land on /?tab=email / /?tab=discs: show the clean address (R14-60) */
    try { var nt = window.ffPathTab(window.location.pathname) ? '' : (want === 'email' ? '/playlists' : want === 'discs' ? '/market' : ''); if (nt && window.location.pathname === '/' && /^\?tab=(email|discs|dvds|store)$/.test(window.location.search.replace(/&_su_rec(_id)?=[^&]*/g, ''))) history.replaceState(history.state, '', nt + window.location.hash); } catch (e) {}
    handleStripeReturn();
    handlePortalReturn();
    applyCaptureQuery();
    document.querySelectorAll('.ff-kalshi-logo').forEach(function (el) { el.innerHTML = kalshiLogo(16); });
    document.querySelectorAll('.ff-poly-logo').forEach(function (el) { el.innerHTML = polyLogo(16); });
    document.querySelectorAll('.ff-kalshi-mark').forEach(function (el) { el.innerHTML = kalshiMark(16); });
    document.querySelectorAll('.ff-poly-mark').forEach(function (el) { el.innerHTML = polyMark(16); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  // theme.js starts the episode typewriter on window 'load'; re-assert the right phrase set right after it.
  window.addEventListener('load', function () { setTimeout(function () { if (FF.tab === 'predictions') restartTypewriter(); }, 30); });
  var rz = null; window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(function () { if (FF.tab === 'predictions' && FF.up) renderChart(); }, 150); });
})();
